export const da = {
    addDatabase: {
        addDatabase: "TilfÃ¸j database",
        addFromFile: "TilfÃ¸j fra fil",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Alle pakker",
        onePackage: "Ãn pakke",
        priceType: "Pris type",
        setPriceVatVisibility: "Moms synlighed",
        setVisibilityAndOrder: "Indstil synlighed og rÃ¦kkefÃ¸lge pÃ¥ pristyper",
        withAndWithoutVat: "BÃ¥de med og uden moms",
        withVat: "Kun med moms",
        withoutVat: "Kun uden moms"
    },
    barvis: {
        base: "Basenavn",
        bigCanSize: "Stor dÃ¥se/spand",
        coating: "Grundmaling",
        identifier: "Identifikator",
        laboratory: "Laboratorium",
        orderOverview: "Ordreoversigt",
        rank: "Rangorden",
        smallCanSize: "Lille dÃ¥se/spand"
    },
    basicSetup: {
        alreadyLoggedIn: "Du er allerede logget ind som %{login}.",
        askSupplier: "Bed din softwareleverandÃ¸r om at tildele dig mere licens.",
        asterisk: "Felter markeret med en stjerne skal udfyldes.",
        identificationKeys: "IdentificeringsnÃ¸gler",
        importCustomData:
            "Hvis det er relevant, skal du importere dine brugerdefinerede data fra det tidligere toningssoftware.",
        learnIdentification: "LÃ¦r identifikationsnÃ¸glen fra din softwareleverandÃ¸r.",
        login: "FÃ¸lgende trin af den indledende opsÃ¦tning krÃ¦ver administrative rettigheder",
        noDatabase: "Ingen databaser er tilfÃ¸jet endnu, mindst en skal vÃ¦re indsat.",
        offlineLicensing: "Offline licensering",
        productSelection: "Produktvalg",
        registrationForm: "Registreringsformular",
        seeQuestionMark: "Se de smÃ¥ spÃ¸rgsmÃ¥lstegn for at lÃ¦re mere om indstillingen.",
        selectDefaultPrinter: "VÃ¦lg standardprinter, og indstil yderligere konfiguration.",
        selectDefaultTemplate:
            "VÃ¦lg standardskabelon fra de allerede eksisterende, opret en ny eller oploade din egen.",
        selectDispenser: "VÃ¦lg den tonermaskinetype du bruger.",
        selectLanguage: "VÃ¦lg sprog.",
        selectProducts: "VÃ¦lg et af de tilgÃ¦ngelige produkter, som du vil aktivere.",
        selectSpectroType: "VÃ¦lg den spektrometertype du benytter.",
        setAdditionalPrinterOptions: "Angiv yderligere printerindstillinger.",
        setAutomaticUpdates: "Angiv indstillingerne for automatiske opdateringer.",
        setCustomItems: "Angiv specialfremstillede varer og datasynlighed. Rul ned for at se flere muligheder",
        setEnvironment: "Angiv softwarets overordnede omgivelser. Rul ned for at se flere muligheder.",
        setFormulaRepresentation: "Angiv receptsreprÃ¦sentationen. Rul ned for at se flere muligheder.",
        summary:
            "Du kan Ã¦ndre i disse indstillinger pÃ¥ ethvert givent tidspunkt og finde flere konfigurationsmuligheder. Nyd at bruge %{name}!",
        summarySuccess: "Du er opsat i systemet!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Angiv kanisterniveau",
        criticalLevelCanister: "Kritisk kanisterniveau",
        fillToMax: "Fyld til max",
        maxDispenseLevel: "Maksimale dosering",
        otherCanisters: "Andre kanisterniveauer",
        warningLevelCanister: "Advarsel om kanisterniveauer"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "TilgÃ¦ngelige servicehandlinger",
        canisterInformation: "Kanisterinformation",
        canisterPreview: "ForhÃ¥ndsvisning af kanistre",
        currentLevel: "NuvÃ¦rende niveau",
        errors: "Fejl",
        fillState: "PÃ¥fyldningsstatus",
        fillToMax: "Fyld til max",
        fillingAmount: "PÃ¥fyldningsmÃ¦nge",
        finalLevel: "Endelige niveau",
        minimumAmount: "MinimumsmÃ¦ngde",
        minimumLevel: "Minimumniveau",
        moveTableToRefill: "Flyt bordet for at genopfylde",
        refillNoAmount: "Ingen mÃ¦ngde registreret",
        refillOverLimit: "Den intastede mÃ¦ngde overskrider den maksimale kanisterkapacitet.",
        refillSummary: "%{amount} %{unit} %{colorant} pasta bliver tilfÃ¸jet til kanister %{canisterId}.",
        systemWarningAmount: "Systemadvarende mÃ¦ngde",
        warningAmount: "Advarslende mÃ¦ngde"
    },
    changeDatabase: {
        changeDatabase: "Ãndre databasen ",
        databaseWarning: "Databasen %{databaseName} kan ikke anvendes, da"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "RengÃ¸r alle kanaler",
        cleanChannels: "RengÃ¸r kanaler",
        cleaningTime: "RengÃ¸rringstid",
        selectChannels: "VÃ¦lg kanaler",
        startCleaning: "Start rengÃ¸rring "
    },
    clientServerSettings: {
        activeServer: "Aktiv server",
        addNewServer: "TilfÃ¸j ny server",
        availableServers: "Andre tilgÃ¦ngelige servere",
        clientIdentifier: "Klientidentifikator",
        clientServerSettings: "Klient/server indstillinger",
        disabledStatus: "Deaktiveret",
        editServer: "Rediger server",
        fillRequiredFields: "Obligatoriske felter skal udfyldes",
        noOtherServers: "Der er ingen andre servere til rÃ¥dighed",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "OverfÃ¸r",
        serverName: "Servernavn",
        serverNameMissing: "Servernavn skal udfyldes",
        stabileConnection: "Brug statisk IP-adresse for at sikre stabil forbindelse.",
        wrongFormatIp: "Forkerte format af IP adresse"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Farvetone",
        fandeckPosition: "Farvekortsposition",
        moreInfoIcons: "Mere information ikoner",
        notExistingFormula: "Ikke-eksisterende recept",
        orderBy: "Bestilling af",
        selectYourGrid: "VÃ¦lg dit gitter",
        showInPanel: "Vis i panelet",
        warningIcon: "Ikke-eksisterende recept advarselsikon"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Antal tonepastaer:",
        preview: "ForhÃ¥ndsvisning",
        prices: "Priser"
    },
    currencySettings: {
        addNewCurrency: "TilfÃ¸j ny valuta",
        codePlaceholder: "Kode",
        currencySettings: "Valutaindstillinger",
        namePlaceholder: "Navn",
        ratePlaceholder: "Valutakurs",
        setDecimalPlaces: "Indstil antal decimaler",
        setMainCurrency: "Indstil primÃ¦re valuta",
        setRounding: "Afrunding",
        symbolPlaceholder: "Symbol"
    },
    customFandecks: {
        customFandecks: "Specialfremstillet farvekort",
        deleteButtonWarning: "Alle formler i farvekortet vil ogsÃ¥ blive fjernet.",
        deleteCustomFandeck:
            "Vil du virkelig slette dette specialfremstillede farvekort? Alle formler i farvekortet vil ogsÃ¥ blive slettet.",
        disableStandardFandecks: "Vis kun kundefarvekort",
        enableStandardFandecks: "Vis standard farvekort",
        fandeckName: "Farvekorts navn "
    },
    customRedlike: {
        addColorantFromBrand: "TilfÃ¸j pasta fra %{brandName}",
        addNewCustomer: "TilfÃ¸j ny kunde",
        addNewNote: "TilfÃ¸j ny note",
        addedDate: "Yderligere data",
        addedQuantity: "Yderligere kvantitet",
        availableMachine: "Maskinen er tilgÃ¦ngelig",
        brand: "MÃ¦rke",
        brandPlease: "Venligst vÃ¦lg mÃ¦rke",
        cancelCustomer: "Annuller kunde",
        colorPlease: "VÃ¦lg venligst farve",
        confirmCustomerData: "BekrÃ¦ft kundedata",
        confirmNoteData: "BekrÃ¦ft noteoplysninger",
        confirmSelectedUser: "Ãnsker du at bruge denne kunde %{customerName} til denne ordre.",
        confirmed: "BekrÃ¦ftet",
        controlData: "Endelige datakontrol",
        customerCellNumber: "Kundetelefonnummer",
        customerFilter: "Kundefilter",
        customerName: "Kundenavn",
        customerPhone: "Kundetelefon",
        customerPlease: "Venligst vÃ¦lg kunde",
        dateFilter: "Datofilter",
        enterPin: "Indtast din adgangskode",
        enterTheNumberOfPackages: "Indtast antallet af pakker",
        existingCustomer: "Bruger eksisterer allerede",
        fandeckPlease: "VÃ¦lg venligst farvekort",
        fillCanisterHistory: "Udfyld kanister historik",
        findCustomer:
            "For at tildele loyalitetskort til denne ordre skal du scanne stregkode eller sÃ¸ge pÃ¥ email-adresse",
        findCustomerByEmail: "Filtrer kunder pÃ¥ baggrund af email eller stregkode",
        finishPreviousStep: "(Venligst fÃ¦rdiggÃ¸r tidligere trin)",
        formulaUnit: "Receptenhed",
        getBackToList: "Tilbage til kundeliste",
        historyOfOrders: "Ordrehistorik",
        insertNote: "GÃ¥ til indsÃ¦t note",
        loadHistoryOrder: "Ãnsker du at oploade valgte ordre?",
        loyaltyCards: "Loyalitetskort",
        machineIsAvailable: "MASKINEN ER TIL RÃDIGHED",
        machineIsUnavailable: "MASKINEN ER IKKE TIL RÃDIGHED",
        newLoyaltyCard: "Nyt loyalitetskort",
        noAvailableMachine: "Maskinen er ikke til rÃ¥dighed",
        noCustomerSelected: "Ingen kunder er valgt. Ãnsker du at fortsÃ¦tte?",
        notePlease: "Venligst indsÃ¦t note",
        openHistory: "Ãben historik",
        orAdd: "eller tilfÃ¸j kunde",
        orSelect: "eller vÃ¦lg kunde",
        orderModification: "Den originale ordre vil blive Ã¦ndret. Vil du fortsÃ¦tte?",
        orderOverview: "Ordreoversigt",
        orderToMachine: "SEND MIN ORDRE TIL MASKINEN",
        ordersHistory: "Ordrehistorik",
        packagePlease: "VÃ¦lg venligst pakke",
        pleaseSelectBrand: "VÃ¦lg venligst mÃ¦rke",
        previewImage: "IMG forhÃ¥ndsvisning",
        previewPackage: "ForhÃ¥ndsvisning af pakke",
        productPlease: "VÃ¦lg venligst produkt",
        resetFilters: "Nulstil alle filtre",
        searchForHistoricalOrders: "Eller sÃ¸g efter ordrer i historik",
        selectBrand: "VÃ¦lg venligst mÃ¦rke",
        selectColor: "GÃ¥ til at vÃ¦lge farve",
        selectCustomer: "GÃ¥ til at vÃ¦lge kunde",
        selectExistingCustomer: "VÃ¦lg eksisterende kunde",
        selectFandeck: "GÃ¥ til at vÃ¦lge farvekort",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "GÃ¥ til at vÃ¦lge pakke",
        selectProduct: "GÃ¥ til at vÃ¦lge produkt",
        shotsCoefficient: "Shots koefficient",
        showDetail: "Vis detaljer",
        showHideEshopName: "Vis/skjul farvens eshop navn i en separat kolonne",
        showKeyboard: "Vis tastatur",
        skipCustomerButton: "Spring over valgte kunder",
        skipCustomerText: "Spring over, hvis du ikke Ã¸nsker at indtaste en kunde",
        skipNote: "Spring note over og se resumÃ©",
        spectroBrand: "SÃ¸ger i %{brandName}",
        statusAccepted: "accepteret",
        statusCanceled: "annulleret",
        statusCreated: "kreeret",
        statusDone: "udfÃ¸rt",
        statusPartlyDone: "delvis udfÃ¸rt",
        statusPreparing: "forbereder",
        summaryChosenBase: "base",
        summaryChosenBrand: "mÃ¦rke",
        summaryChosenCanSize: "DÃ¥se/Spand stÃ¸rrelse",
        summaryChosenColor: "farve",
        summaryChosenColorCard: "farvekort",
        summaryChosenProduct: "produkt",
        summaryChosenQuantity: "mÃ¦ngde",
        summaryColorPreview: "Farve forhÃ¥ndsvisning",
        summaryCustomNote: "Brugerdefineret note",
        summaryCustomerNumber: "kundenummer",
        summaryFormula: "Recept",
        summaryFormulaNote: "Receptsnote",
        summaryNote: "note",
        sureAboutSend: "Er du sikker pÃ¥ at du Ã¸nsker at sende en ordre?",
        useCustomerInOrder: "Ãnsker du at bruge denne kunde %{customerName} til denne ordre.",
        uuid: "UUID (universelt unik identifikator)",
        viewSummary: "Se resumÃ©",
        volume: "Volumen"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "FastgÃ¸r ordrebekrÃ¦ftigelse",
        pinScreenSaverConfirmation: "FastgÃ¸r skÃ¦rmbesparelsesbekrÃ¦ftelse",
        pinSettingsConfirmation: "Pin-indstilling bekrÃ¦ftelse",
        printAuto: "Tillad automatisk udskrivning",
        printerSettings: "Printerindstillinger",
        selectColorWithFandeck: "Ofte valgte farver og farvekort",
        setKeyboard: "Indstil tastatur",
        setKioskMode: "Indstil fuld skÃ¦rm",
        setLanguage: "Indstil sprog",
        setModule: "Indstil modul",
        setQuickSelect: "Indstil hurtig udvalg",
        setScreensaverTimeout: "Indstil udlÃ¸bstid for pauseskÃ¦rm",
        setUnit: "Indstil enhed "
    },
    customRedlikeMachine: {
        action: "Handling",
        additionalPrint: "Ekstra udskrivninger",
        brand: "MÃ¦rke",
        brandAccess: "Bruger '%{userName}' kan ikke tilgÃ¥ data fra mÃ¦rket '%{brandName}'",
        can: "DÃ¥se/Spand placeret",
        canistersLevel: "Kanisterniveau oversigt",
        closeDetailInformation: "Luk detaljer",
        colorantsAmount: "MÃ¦ngden af tonepasta",
        confirmRefill: "BekrÃ¦ft tonepasta genopfyldning",
        deleteOrder: "Slet ordre",
        dialogNoMachine: "Maskinen er ikke forbundet",
        dialogNoRcc: "Der er ingen RCC (Redlike Control Center) forbundet",
        dispense: "Ton",
        dispenserInErrorState: "Tonemaskinen er i fejltilstand",
        dispensingIsOk: "Tonemaskinen er OK",
        emergencyButtonPressed: "NÃ¸dstopkontakten trykket",
        errorCode: "Fejlkode",
        errorEvents: "Tonemaskinefejl",
        errorReset: "Genstartsfejl",
        explanation: "Forklaring",
        imageNotAvailable: "Billedet er ikke tilgÃ¦ngeligt",
        incorrectCanister: "Den skannede kanister er forkert!",
        incorrectColorant: "Fejl: Den skannede tonepasta er forkert. Venligst vÃ¦lg det korrekte tonepasta.",
        lastEvents: "Sidste begivenhed",
        machineActions: "Tonemaskinesensor",
        machineConfiguration: "Tonemaskinekonfiguration",
        machineError: "Maskinefejl",
        machineIsBusy: "Maskinen er optaget",
        machineNotAvailable: "Maskinen er ikke tilgÃ¦ngelig",
        machineTinting: "Venligst vent, maskinen toner...",
        manualScan: "Manuel scanning",
        notEnoughSpace: "FEJL: Der er ikke nok plads til denne tonepastapakke",
        numberOfCanistersUnderCriticalLevel: "Antal kanister under kritiske niveauer er %{0}",
        numberOfCanistersUnderWarningLevel: "Antal kanister under varslene niveauer er %{0}",
        offlinePressed: "Offline-tasten er aktiveret",
        orderSettings: "Ordreindstillinger",
        otherOrderInformation: "Ordredetaljer",
        packageCount: "Pakke optÃ¦lling",
        packageWithSeparator: "Pakke",
        received: "Modtaget",
        receivedOrders: "Modtagede ordre",
        receivedTime: "Modtagede tidspunkt",
        recirculation: "Recirkulation",
        refillInformation: "Tonepasta: %{0}, Opfyldning: %{1}, Kanister: %{2}",
        resetErrors: "Nulstillingsfejl",
        scanCanister: "Scan denne kanister",
        scanColorantPackage: "Scan den passende tonepastapakke",
        selectedOrder: "Udvalgte ordre",
        shelfMovingDown: "Hylden bevÃ¦ges nedad",
        shelfMovingUp: "Hylden bevÃ¦ges opad",
        solution: "LÃ¸sning",
        startDispensing: "Start toning",
        stirring: "OmrÃ¸ring",
        touchToStartFilling: "Tryk for at starte pÃ¥fyldning af tonepasta",
        unknownBrand: "Ukendt mÃ¦rke"
    },
    customRedlikeSettings: {
        addPos: "Salgsstedsinformation (POS)",
        addServer: "TilfÃ¸j server",
        adminOperations: "Admin arbejdsomrÃ¥de",
        adminSettings: "Admin indstillinger",
        another: "En anden",
        aslOrService: "Tegnesprog eller betjening",
        availableMachines: "TilgÃ¦ngelige maskiner",
        barcode: "Stregkode",
        basicOperations: "Basale aktiviteter",
        canisterBarcodes: "Kanister stregkode",
        canisterLevels: "Kanisterniveauer",
        closeConnection: "Luk forbindelsen",
        closeRedlike: "Luk %{name}",
        databaseList: "Database",
        disabledStatus: "Deaktiveret",
        dispenseLogicType: "Doseringens logiktype",
        dropServers: "FravÃ¦lg server",
        editServer: "Rediger server",
        lastEvent: "Sidste begivenhed",
        logOut: "Log af",
        machineConfiguration: "Konfiguration",
        maxDispenseAmount: "Maksimale doseringsmÃ¦ngde",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        openFrondesk: "Ãben reception",
        print: "Udskrivningsindstillinger",
        rebootPC: "Genstart PC",
        restartRedlike: "Genstart %{name}",
        restoreConnection: "Gendan forbindelse",
        scanCanisterBarcode: "Scan kanisterens stregkode",
        scanOrDeleteCanisterBarcode: "Scan eller slet stregkode",
        setCanisterBarcode: "Indstil kanisterens stregkode",
        swVersion: "Softwareversion",
        systemFunctions: "System funktion",
        userSettings: "Brugerindstillinger "
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Rediger farve",
        editColorant: "Rediger tonepasta",
        emptyColorant: "En af tonepastaerne er tomme",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formel til hovedprodukt",
        formulaForMasterProductWithParam: "Formel til hovedprodukt %{productName}",
        isNotAvailable: "er ikke tilgÃ¦ngelig",
        noBaseSelected: "Base er pÃ¥krÃ¦vet",
        noColorantsSelected: "Ingen tonepasta er valgt",
        noFandeckSelected: "Farvekort er pÃ¥krÃ¦vet",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Produkt er pÃ¥krÃ¦vet",
        productPreview: "ProduktforhÃ¥ndsvisning",
        saveCustomRecipe: "Gem specialtoning",
        saveIsNotAvailable: "Gem er ikke tilgÃ¦ngelig",
        showSiblingProducts: "Vis sÃ¸sterprodukter",
        siblingProducts: "SÃ¸sterprodukter som en funtion af hovedprodukter"
    },
    customersTab: {
        addCustomer: "TilfÃ¸j kunde",
        additionalSettings: "Yderligere indstillinger",
        adress: "Adresse",
        createAndSelect: "TilfÃ¸j og vÃ¦lg",
        createNewCustomer: "Opret en ny kunde",
        editCustomer: "Rediger kunde",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Kontonummer",
        information: "Kontaktinformation",
        listOfCustomers: "Kundeliste",
        rabat: "Rabat",
        selectCustomer: "VÃ¦lg kunde",
        spentLastMonth: "Brugt sidste mÃ¥ned",
        spentMoney: "Brugte penge",
        typeOfMargin: "Typer af profit",
        zipCode: "Postnummer"
    },
    dialog: {
        cheaperColorSearch: "SÃ¸gning efter en billigere farve pÃ¥gÃ¥r",
        competitiveColorSearch: "Simulerende farvesÃ¸gning er i gang",
        reallyChangeModule: "Ãnsker du virkelig at Ã¦ndre modulet?",
        reallyCloseRedlike:
            "Ãnsker du virkelig at lukke %{name}? Alle %{name} paneler vil blive lukket, og ikke gemte Ã¦ndringer vil blive slettet.",
        reallyDeleteOrder: "Ãnsker du virkelig at slette denne ordre? Alt data om denne ordre vil blive slettet.",
        reallyRebootPC:
            "Ãnsker du virkelig at genstarte denne PC? Alle paneler vil blive lukket, og ikke gemte Ã¦ndringer vil blive slettet.",
        reallyRestartRedlike:
            "Ãnsker du virkelig at genstarte %{name}? Alle paneler vil blive lukket, og ikke gemte Ã¦ndringer vil blive slettet.",
        reallyShutdownPc:
            "Ãnsker du virkelig at slukke denne computer? Alle %{name} paneler vil blive lukket, og ikke gemte Ã¦ndringer vil blive slettet. ",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Doser kun det maksimale tonbare mÃ¦ngde",
        2: "Tillad manuel dosering med brug af skala for mÃ¦ngder over den maksimale tonbare mÃ¦ngde",
        3: "Genopfyld under toningen (delt belÃ¸b i mindre bidder)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Farvekort navn"
    },
    editFormulaRgbModal: {
        apply: "PÃ¥fÃ¸r",
        blue: "BlÃ¥",
        green: "GrÃ¸n",
        modalLabel: "Rediger farve",
        red: "RÃ¸d",
        tryGenerateRgb: "ForsÃ¸g at generere RGB vÃ¦rdier baseret pÃ¥ pastamÃ¦ngde"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Luk formelfanen automatisk",
        allowBarcodes: "Tillad stregkode",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Tillad kunder",
        allowDeleteConfirmation: "Tillad sletningsbekrÃ¦ftelse",
        allowDiskSpaceNotification: "Tillad meddelelse om diskplads",
        allowDispensing: "Tillad toning",
        allowFileTransfer: "Tillad automatisk filoverfÃ¸rsel",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Tillad panel af formelstatus",
        allowInternalNotes: "Tillad interne noter",
        allowLight: "Tillad %{name}",
        allowOrderNotificationModal: "Vis nye ordremeddelelser",
        allowOrdering: "Tillad bestilling",
        allowPricing: "Tillad prissÃ¦tning",
        allowPrint: "Tillad udskrivning",
        allowProductPreviewImage: "Vis produktbilledeeksempel",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Tillad sÃ¸gning for billigere farver",
        allowSound: "Tillad ordre notifikationer med lyd",
        allowSpectro: "Tillad spektrometer",
        allowTabs: "Tillad faner",
        applyZoom: "Tillad zoom",
        automaticLogout: "Automatisk log ud",
        barcodeScan: "Barcode scanning",
        canisterBarcode: "Kanister stregkode",
        canisterLevel: "Kanisterniveau",
        changelog: "Changelog",
        closeTab: "Luk fane",
        colorDifference: "Color difference",
        colorPanelNavItem: "Farvepanel",
        competitiveColorSearch: "Simulerende farvesÃ¸gning",
        customBanner: "Specialfremstillet banner",
        customCurrencyFormat: "Valutaformat",
        customDateFormat: "Datoformat",
        customNumberFormat: "Nummerformat",
        customTimeFormat: "Tidsformat",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Vis rabat",
        dispensingHistory: "Toningshistorik",
        dispensingNotes: "Tillad toningsnoter",
        enableCustomers: "AktivÃ©r kunder",
        enableDeleteConfirmation: "AktivÃ©r sletningsbekrÃ¦ftelse",
        enableDispensing: "AktivÃ©r toning",
        enableLight: "AktivÃ©r %{name}",
        enableMarginMarkup: "AktivÃ©r profit (margin) eller Ã¸nskede profitprocent (markup)",
        enableNotes: "AktivÃ©r noter",
        enableOrdering: "AktivÃ©r bestilling",
        enableProductPreviewImage: "AktivÃ©r produktbillede",
        enableSpectro: "AktivÃ©r spektrometer",
        enableVirtualKeyboard: "Tillad virtuelt tastatur",
        environmentsSettings: "Omgivelsesindstillinger",
        exportTranslationKeys: "Eksporter oversÃ¦ttelsesnÃ¸gler",
        formulaNotes: "Tillad receptsnote",
        hintTooltips: "VÃ¦rktÃ¸jstip",
        image: "Farve + billede/mere information",
        keyboardShortcuts: "Tastatur genveje",
        languageBased: "Sprog baseret",
        lockYourComputer: "LÃ¥s din computer",
        machineReset: "Nulstilling af maskine",
        manageTranslations: "Administrer oversÃ¦ttelse",
        margin: "Kun profit (margin)",
        markup: "Kun Ã¸nskede profitprocent (markup)",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maksimal antal receptfaner",
        memoryTabs: "Gem nyligt Ã¥bnede faner",
        moreInfo: "Farve + billede + mere information",
        navigationItems: "Indstillinger for navigationselementer",
        newTab: "Ny fane",
        numberOfPriceGroups: "Antal prisgrupper",
        order: "Ordre",
        orderId: "Ordre ID",
        ordersHistory: "Ordrehistorik",
        overwriteLastTab: "Overskriv den sidste receptfane",
        priceCalculation: "Prisberegning",
        priceDefBothPurchasePrimary: "Begge - med kÃ¸b som den primÃ¦re",
        priceDefBothSellPrimary: "Begge - med salg som den primÃ¦re",
        priceDefPurchaseOnly: "Kun indkÃ¸bspris",
        priceDefSellOnly: "Kun salgspris",
        priceDefinition: "Prisdefinition",
        priceGroupsEnabled: "Aktiver prisgrupper",
        runLightAtStartUp: "KÃ¸r %{light} ved opstart",
        screenSaverTimeout: "PauseskÃ¦rmens udlÃ¸bstid",
        selectedSpectro: "%{spectro} spektromter er valgt.",
        selectedSpectroNone: "Ingen spektrometer er valgt.",
        setAutomaticClientStart: "KÃ¸r %{name} ved computer opstart",
        setCustomHomeButton: "Startknap handlinger",
        setDecimalPlaces: "Indstil antal decimaler",
        setFormulaPreview: "ReceptforhÃ¥ndsvisning",
        setFormulaUnit: "Indstil receptenhed",
        setFts: "Brug fuldtekstsÃ¸gning",
        setInfoItemInRgb: "Data for forhÃ¥ndsvisning af farver",
        setKeyboardShortcuts: "Indstil tastaturgenveje",
        setKioskMode: "Indstil fuld skÃ¦rm tilstand",
        setKioskModeOff: "SlÃ¥ fuld skÃ¦rm tilstand fra",
        setKioskModeOn: "SlÃ¥ fuld skÃ¦rm tilstand til",
        setNavigationItems: "Indstil navigationselementer",
        setNavigationItemsList: "Indstil synlighed og rÃ¦kkefÃ¸lge for navigationselementer",
        setOrderSearchItems: "Indstil ordresÃ¸gningsparametre",
        setRounding: "Indstil afrunding",
        setSearchParameters: "Indstil receptssÃ¸gningsparametre",
        setTabLimit: "Indstil fane begrÃ¦nsninger",
        setYourLanguage: "Indstil sprog",
        setZoom: "Indstil zoom",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Denne indstilling kan ikke Ã¦ndres da dialogboksen er blevet deaktiveret i Maskinindstillinger",
        sortItems: "Sorter navigationselementer",
        startDispensing: "Start toning",
        stir: "OmrÃ¸r"
    },
    error: {
        errorDetail: "Fejldetaljer",
        errorOccurred:
            "Der opstod en uventet fejl. Kontakt vores support pÃ¥ %{0}, og vi vil vende tilbage til dig sÃ¥ hurtigt vi kan.",
        hideDetail: "Skjul detaljer"
    },
    favoritesTab: {
        addFolder: "TilfÃ¸j mappe",
        closeTabToLoadFormula:
            "Venligst luk en af dine formler for at Ã¥bne en ny fane. Du er nÃ¥et det maksimale antal Ã¥bne faner",
        deleteFolder: "Slet mappe",
        editFolder: "Rediger mappe",
        favoriteFormulas: "Favorit recepter",
        formulaNotes: "Receptsnote",
        message: {
            formulasFromFolder: "Recept fra mappe",
            moveAllFormulas: "Flyt alle recepter fra denne mappe til overordnede",
            removeAllFormulas: "Fjern alle recepter fra denne mappe",
            wantToDeleteFolder: "Ãnsker du virkelig at slette denne mappe?"
        },
        newFolder: "Ny mappe",
        packages: "Pakker",
        pricePerPackage: "Pris pr. pakke",
        regularPrice: "Almindelig pris",
        removeFromFavorites: "Fjern fra favorit",
        specialPriceOff: "SÃ¦rtilbud %{number}% rabat",
        specialPriceVIP: "SÃ¦rtilbud VIP"
    },
    fileTransfer: {
        afterImport: "Efter import",
        alreadyExists: "Opgave for den givne type og format findes allerede",
        customFormulaSimple: "Enkelt brugerdefineret formel",
        direction: "Retning",
        exportTask: "Fileksportopgave",
        fileTransferNotification: "Meddelelse om filoverfÃ¸rsel",
        flashMessage: "Flash besked",
        importTask: "Filimportopgave",
        noInformation: "Ingen information",
        protocol: {
            folder: "Mappe",
            ftp: "FTP protokol",
            ftps: "FTPS protokol",
            redlikeStorage: "%{softwareName} FTP storage protokol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Fernmappe",
        startType: "Start type",
        statusbar: "Oplysninger om statuslinjen",
        testConnection: "Testforbindelse",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Forbrugertype",
        filter: "Filter",
        from: "Fra",
        to: "Til"
    },
    findText: {
        findTextTitle: "SÃ¸g efter tekst",
        removeMarks: "Fjern mÃ¦rke",
        search: "SÃ¸g ord"
    },
    flashMessage: {
        VMNotAllowed: "Virtuel maskine er ikke tilladt.",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Automatisk databaselogin mislykkedes.",
        autotaskDuplicateName:
            "Databasens integritetsfejl: %{0} vare med %{1} %{2} findes allerede, brug venligst forskellige %{3}.",
        barcodeIsUsed: "Stregkoden bruges allerede",
        barcodeNotFound: "Stregkoden blev ikke fundet.",
        bugReportSent: "Din softwarefejlrapport er blevet succesfuldt sendt.",
        cannoctConnectToServer: "Kan ikke forbinde til serveren.",
        cannotWriteLicense: "Kan ikke skrive licens.",
        clientConnectionRejected: "Forbindelse er blevet afvist.",
        clientNotLoggedIn: "Klienten er ikke logget ind.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty: "Resultaterne af den simulerende farvesÃ¸gning er tom",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Computeren er blevet dateret tilbage.",
        connectionFailed: "Forbindelsestest fejlede: %{0}",
        connectionSuccess: "Forbindelsestesten lykkedes",
        corruptedLicenseFile: "Licensfilen er beskadiget.",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Kunden blev ikke fundet.",
        dataNotAvailable: "Server kan ikke oprette forbindelse til databasen.",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Der opstod en uventet fejl under den sidste serverhandling.",
        deleteAll: "Slet alle.",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Du kan deaktivere vinter plug-in ved hjÃ¦lp af rullelisten i hÃ¸jre side af fanenavigering.",
        duplicateBarcode: "Der findes allerede en dubletstregkode",
        duplicateName: "Duplikat, navn findes allerede.",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licensen er udlÃ¸bet.",
        exportSuccess: "Data er blevet eksporteret succesfuldt.",
        fandeckExist: "Dette specialfremstillet farvekort navn findes allerede.",
        featureNotAutorized: "Funktionen er ikke godkendt.",
        fileExportComplete: "Filen blev succesfuldt eksporteret.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Filen fandtes ikke eller var tom.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Kunne ikke behandle data i filen, filen er ikke gyldig.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Filversionen kunne ikke registreres.",
        filetransferNoData: "Ingen databaseforbindelse, tjek indstillinger",
        formulaDataUnavailable: "Receptdata er ikke tilgÃ¦ngelig.",
        helperDefaultMessage: "Der opstod en uventet fejl under den sidste handling fra hjÃ¦lpe-serveren.",
        helperServerError: "HjÃ¦lpe-server fejl.",
        importAborted: "Importprocessen er afbrudt.",
        importSuccess: "Data er blevet importeret succesfuldt.",
        incompatibleBaseCan: "Base kan ikke vÃ¦re kompatibel med det givne produkt, base og pakke.",
        incorrectPassword: "Din gamle adgangskode er forkert. Indtast en korrekt.",
        invalidCurrency: "Valutakode er ugyldig. Euro er indstillet som en standardvaluta.",
        invalidDatabaseName: "Databasens navn er ugyldigt.",
        invalidEmail: "Din email er ugyldig.",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Ugyldig virksomhedsbruger nÃ¸gle.",
        invalidLicenseFile: "Ugyldig licensfil.",
        invalidLicenseIdentificationKeys: "Din licensidentifikationsnÃ¸gler er ugyldige.",
        invalidLicenseKey: "Din licens er ugyldig",
        invalidLicenseProduct: "Licensfilen matcher ikke produktet.",
        invalidRccResponse:
            "Der opstod en uventet fejl under behandlingen af det sidste RCC-svar (Redlike Control Center).",
        invalidServerResponse: "Der opstod en uventet fejl under behandlingen af det sidste serversvar.",
        invalidUrl: "URL er ugyldig.",
        itemNotFound: "Produktet blev ikke fundet.",
        keyboardShortcutUsedInModal: "Denne tastaturgenvej kan ikke bruges i pop op-vinduet. Luk fÃ¸rst pop op-vinduet.",
        keyboardShortcutValidation: "Ãn tastaturgenvej kan ikke indstilles til to forskellige handlinger.",
        licenseHasBeenRevoked: "Din licens er blevet ophÃ¦vet. Kontakt din softwareleverandÃ¸r for at fornye den.",
        licenseProlongationNeeded: "LicensforlÃ¦ngelse nÃ¸dvendig (tilslut pc til internettet for at fÃ¥ en ny licens)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Produktet er oprindeligt licenseret pÃ¥ en anden computer.",
        logFileArchiveDownloadComplete: "Download af logarkiv er succesfuldt afsluttet.",
        loginError: "Der opstod en uventet fejl under login.",
        logoutError: "Der opstod en uventet fejl under log ud.",
        machineIsConnecting: "Maskinen tilslutter, vent venligst.",
        machineIsNotConnected:
            "Din maskine er IKKE TILSLUTTET til RCC. Kontroller RCC-konfigurationen (Redlike Control Center).",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maksimal mÃ¦ngde faner er nÃ¥et, luk venligst en.",
        noTemplate: "Udskrivning kan ikke udfÃ¸res, da der ikke er nogen skabeloner til rÃ¥dighed.",
        openNewTab: "Ãbn en ny receptfane for at indlÃ¦se recepten ved hjÃ¦lp af stregkode",
        orderAlreadyAcquired: "Ordren er allerede erhvervet, den skal frigives fÃ¸rst.",
        orderCreated: "Bestillingen er blevet sendt.",
        passwordIsNotUnique: "Den nye adgangskode skal afvige fra den gamle.",
        printCannotBeCarriedOut: "Udskrivning kan ikke udfÃ¸res, da printernavnet er ugyldigt.",
        problemWithFileExport: "Der opstod en fejl under lagring af filen pÃ¥ disken.",
        productFileWarning: "Produktfil er kun tilgÃ¦ngelig online.",
        productNotLicensed: "Produktet er ikke licenseret.",
        rccDefaultMessage: "Der opstod en uventet fejl under den sidste RCC-handling (Redlike Control Center).",
        rccError: "RCC-fejl (Redlike Control Center)",
        rccNeedRestart: "Genstart din RCC (Redlike Control Center) igen.",
        restoredSettings: "Indstillingerne er blevet gendannet.",
        revokedLicense: "Licensen er blevet ophÃ¦vet.",
        runningOutOfSpace: "Computeren er ved at lÃ¸be tÃ¸r for ledig plads.",
        savedFormulaToHistory: "Recept er blevet gemt i tonehistorik.",
        savedLogArchive: "Logarkiv er blevet gemt i dit bibliotek.",
        scanning: "Scanning er i gang",
        serverError: "Serverfejl",
        setClientIdentifier: "Angiv fÃ¸rst din klient-id.",
        showLess: "Vis mindre",
        showMore: "Vis mere",
        spectroIsDisconnecting: "Spektrometer kobler fra, vent venligst.",
        spectroIsNotConnected:
            "Spektrometer er IKKE TILSLUTTET i dette Ã¸jeblik. Kontroller RCC-konfigurationen (Redlike Control Center).",
        spectroIsNotSelected:
            "Spektrometer er IKKE VÃLGT i dette Ã¸jeblik. Kontroller RCC-konfigurationen (Redlike Control Center).",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Ukendt fejl: %{0}",
        userAlreadyLoggedIn: "Du er allerede logget ind.",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Kunne ikke oprette forbindelse til Web Api-serveren.",
        webApiInternalError: "Web Api-server - intern fejl",
        webApiInvalidUser: "Web Api-server - ugyldig bruger",
        webApiNoLicenseAvailable: "Web Api-server - ingen licens tilgÃ¦ngelig",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Forkerte format til %{0} Indtastning.",
        wrongRccVersion:
            "Venligst tjek din version af RCC (Redlike Control Center). Din klient er kun kompatibel med RCC (Redlike Control Center) %{0}. "
    },
    footer: {
        aboutApplication: "Om ansÃ¸gning",
        activeUser: "Aktiv bruger",
        logOut: "Log ud",
        machineErrors: "Maskine fejl"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Alle enheder, der er tilgÃ¦ngelige i databasen",
        allowCustomFormulas: "Tillad specialtoninger",
        allowCustomPackageSize: "Tillad specialfremstillet pakkestÃ¸rrelse",
        allowFormulaAutomaticNaming: "Tillad automatisk navngivning",
        automaticNaming: "Automatisk receptsnavngivning",
        basePanelSize: "Indstil stÃ¸rrelse pÃ¥ bundpanel",
        bippPanelSize: "Indstil basens stÃ¸rrelse i produkt panelet",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Formelkode som den primÃ¦re",
        colorPanel: "Farvepanel",
        colorPreviewAsImage: "Farveeksempel som billede",
        colorPreviewResizable: "Visning af farverÃ¦ndringer",
        competitiveColorSearch: "Simulerende farvesÃ¸gning",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Specialtoninger",
        customPackageSettingsUnitGrav: "Brugerdefinerede produktindstillinger gravimetrisk enhed",
        customPackageSettingsUnitVol: "Tilpassede produktindstillinger volumetrisk enhed",
        customPackageSize: "Specialfremstillet pakkestÃ¸rrelse",
        customUnits: "VÃ¦lg special enheder",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Rediger tonepastaer",
        editColorantsAllowed: "Tillad tonepastaredigering",
        fandeckPanelSize: "Indstil stÃ¸rrelse af farvekortets panel",
        favoriteFormulas: "Favorit recepter",
        formulaColorPreview: "ForhÃ¥ndsvisning af receptens farve",
        formulaDataSettings: "Receptdataindstillinger",
        formulaPanel: "Receptpanel",
        formulaPanelSize: "Angiv formelpanelets stÃ¸rrelse",
        formulaSettings: "Receptindstillinger",
        generateColorPreview: "Generer farve forhÃ¥ndsvisning",
        gravimetricOnly: "Kun gravimetriske enheder",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Brug kun billede fra den lokale database",
        imagesOnline: "PrÃ¸v fÃ¸rst og fremmest at Ã¥bne et online billede, hvis det mislykkes, Ã¥bn billedet lokalt",
        infoPanelResizable: "Infopanel til markering for flere Ã¦ndringer",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Enheden afhÃ¦nger af det valgte produkt",
        productFilesDialog: "Vis dialog for at Ã¥bne lokal fil eller online fil",
        productFilesLocal: "Brug kun produktfiler fra lokal database",
        productFilesOnline: "PrÃ¸v fÃ¸rst og fremmest at Ã¥bne online produktfil, hvis det mislykkes, Ã¥bn lokal fil",
        productPanelSize: "Indstil produktpanelets stÃ¸rrelse",
        searchPanelQuickSelect: "Hurtig valg",
        setAdditionalFormulaPanel: "Indstil ekstra receptpanel",
        setCompetitiveColorSearch: "Tillad simulerende farvesÃ¸gning",
        setInitialFormulaPanel: "Indstil indledende receptpanel ",
        setMaxToleranceForCompetitiveColors: "Indstil maksimal tolerance for simulerende farvesÃ¸gning",
        setNumberOfCompetitiveColors: "Indstil antal af simulerende farver",
        setSearchPanel: "Indstil sÃ¸gepanel",
        setVisibilityAndOrder: "Indstil synlighed og rÃ¦kkefÃ¸lge af forskellig  receptdata",
        setVisibleUnit: "Indstil synlige enhed",
        showColorPreview: "Vis forhÃ¥ndsvisningen af farven",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Pasta udvÃ¦lgelsespanel",
        useBase: "Brug markeringselementet til basen",
        useBaseInProductPackage: "Brug markeringselementet til basen i produktet",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Brug markeringselementet til produktet",
        useProductCode: "Brug af produktkode",
        useProductGroups: "Brug produktgrupper",
        volumetricOnly: "Kun volumetriske enheder"
    },
    general: {
        accepted: "Accepted",
        active: "Sidste aktivitet",
        actual: "Virkelig",
        actualLevel: "NuvÃ¦rende niveau",
        add: "TilfÃ¸j",
        addColorant: "TilfÃ¸j tonepasta",
        addColorantForPackage: "Add colorant for package",
        addFile: "TilfÃ¸j fil",
        all: "Alle",
        amount: "MÃ¦ngde",
        applyNow: "Apply now",
        attachments: "VedhÃ¦ftninger",
        automaticCorrection: "Automatic correction",
        automatically: "Automatisk",
        available: "TilgÃ¦ngelig",
        back: "Tilbage",
        base: "Base",
        baseInProductPackage: "Base i produkt og pakke",
        batchNumber: "Batch number",
        bottom: "Bund",
        buildingSite: "Building site",
        calculate: "Beregn",
        can: "DÃ¥se/spand",
        canSize: "DÃ¥se/spand stÃ¸rrelse",
        cancel: "Annuller",
        canister: "Kanister",
        canisterId: "Kanister ID",
        canisterIndex: "Kanister Index",
        canisters: "Kanistre",
        cap: "LÃ¥g",
        capacity: "Kapacitet",
        channels: "Kanaler",
        choose: "VÃ¦lg",
        city: "By",
        clean: "RengÃ¸r",
        clear: "Klar",
        client: "Klient",
        close: "Luk",
        closeAll: "Luk alt",
        collapseAll: "Skjul alle",
        color: "Farve",
        colorCode: "Farvekode",
        colorFile: "Colorfile",
        colorName: "Farvenavn",
        colorPreview: "ForhÃ¥ndsvisning af farve",
        colorant: "Tonepasta",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Tonepastapakke",
        colorants: "Tonepastaer",
        colors: "Colors",
        company: "Firma",
        competitiveColor: "Competitive color",
        confirm: "BekrÃ¦ft",
        confirmDeletion: "Ãnsker du virkelig at slette denne vare permanent?",
        confirmHelpSettings: "Ãnsker du virkelig at gemme denne blanket og efterlade felt tomt?",
        connect: "Forbind",
        continue: "FortsÃ¦t",
        correction: "Correction",
        country: "Land",
        created: "Kreeret",
        creationDateOf: "Creation date of",
        criticalLevel: "Kritisk niveau",
        currency: "Valuta",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Specialfremstillet",
        customData: "Custom data",
        customFandeck: "Specialfremstillet farvekort",
        customFormula: "Modeficer receptindstillinger",
        customPackage: "Specialfremstillet",
        customPackageSettings: "Modeficer produktindstillinger",
        customer: "Kunde",
        customerVersion: "Kunudeversion",
        customers: "Kunder",
        database: "Database",
        date: "Dato",
        default: "Standardindstillinger",
        delete: "Slet",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Beskrivelse",
        disconnect: "Afbryd",
        discount: "Rabat",
        discover: "Opdag",
        dispense: "Doser",
        dispensing: "Doser",
        doNotShowAgain: "Vis ikke denne meddelelse igen.",
        downloadingFile: "Downloader filer",
        edit: "Rediger",
        email: "Email",
        enabled: "Aktiveret",
        error: "Fejl",
        expandAll: "Udvid alle",
        exportData: "Eksporter data",
        exportPdf: "Eksporter PDF",
        fan: "Farvekort",
        fandeck: "Farvekort",
        fandeckCode: "Fandeck code",
        fandeckName: "Farvekort navn",
        fandecks: "Farvekort",
        favorite: "Favorit",
        fileTransfer: "FiloverfÃ¸rsel",
        filling: "Spartling",
        fillingDate: "PÃ¥fyldningsdato",
        find: "Find",
        finish: "FÃ¦rdigt",
        finishedCorrection: "Finished correction",
        formula: "Recept",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "FÃ¥ QR-kode",
        gravimetric: "Gravimetrisk",
        historical: "Historical",
        history: "Historik",
        hours: "Hou.",
        id: "ID",
        images: "Billeder",
        in: "Ind",
        index: "Indeks",
        insertBarcode: "Venligst indtast stregkode",
        install: "Installer",
        installed: "Installeret",
        instructions: "Instruktioner",
        internalNote: "Intern besked",
        interval: "Interval",
        ip: "IP adresse",
        itemNumber: "Varenr.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "BegrÃ¦nsning",
        load: "Hent ind",
        loadFormula: "IndlÃ¦s recept",
        localVersion: "Lokal version",
        machine: "Maskine",
        manualCorrection: "Manual correction",
        manually: "Manualt",
        margin: "Profit (margin)",
        markup: "Ãnskede profitprocent (markup)",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Maksimale niveau",
        maxValue: "Maks.",
        maximum: "Maksimal",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarisme",
        minimum: "Minimal",
        minutes: "Min.",
        missingItem: "Manglende vare",
        missingRequiredItems: "Alle nÃ¸dvendige felter (markeret med en stjerne) skal udfyldes",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Mere",
        moreInfo: "Mere information",
        moveDown: "Flyt nedad",
        moveUp: "Flyt opad",
        myOrders: "Mine ordre",
        name: "Navn",
        nameTitle: "Navn",
        new: "Ny",
        next: "NÃ¦ste",
        no: "Ingen",
        noColorantsAvailable: "Ingen tonepasta tilgÃ¦ngelig",
        noFormulas: "Ingen recept endnu",
        noPricesAvailable: "Ingen priser til rÃ¥dighed",
        nominalAmount: "Nominel mÃ¦ngde",
        notAvailable: "Ikke tilgÃ¦ngelig",
        note: "Note",
        numberOfCanisters: "Antal kanister",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Antal markater",
        numberOfPackages: "Antal pakker",
        off: "Slukket",
        ok: "Okay",
        on: "TÃ¦ndt",
        onFocus: "I fokus",
        open: "Ãben",
        operator: "Operator",
        options: "Muligheder",
        order: "Order",
        other: "Andre",
        otherError: "Andre fejl",
        out: "Ud",
        overwrite: "Overwrite",
        package: "Pakke",
        packagePreview: "ForhÃ¥ndsvisning af pakke",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "Vent venligst",
        previous: "Previous",
        price: "Pris",
        priceGroup: "Prisgruppe",
        print: "Udskrivning",
        printTask: "Udskrift",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "Produktkode",
        productName: "Produktnavn",
        products: "Produkter",
        pump1: "Pumpe 1",
        pump2: "Pumpe 2",
        purchasePrice: "KÃ¸bspris",
        purge: "Rensning",
        qualityControl: "Quality control",
        quantity: "MÃ¦ngde",
        quantityQty: "QTY",
        quickTint: "Hurtig toning",
        rccIsNotAvailable: "RCC er ikke tilgÃ¦ngelig",
        rccIsNotConnected: "RCC (Redlike Control Center) er ikke forbundet",
        rccNotLicensed: "RCC er ikke licenseret",
        reconnect: "Forbind igen",
        refill: "Genopfyld",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Nulstil",
        restart: "Genstart",
        restore: "Gendanne",
        retint: "Omtone",
        revision: "Revision",
        safetySheet: "Sikkerhedsblad",
        save: "Gem",
        saveAs: "Gem som",
        saveToDispensingHistory: "Gem til historik",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sek.",
        select: "Select",
        selectAll: "VÃ¦lg alle",
        selectChannels: "VÃ¦lg kanaler",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Salgspris",
        settings: "Indstillinger",
        shelf: "Hylde",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "StÃ¸rrelse",
        skip: "Spring over",
        smartPurge: "Smart udrensning",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometer",
        standardFormula: "Standard formel",
        status: "Status",
        street: "Gade",
        sum: "Sum",
        summary: "ResumÃ©",
        sync: "Synkroniser",
        technicalSheet: "Teknisk datablad",
        templates: "Skabeloner",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "At tone",
        top: "Ãverst",
        total: "Total",
        totalAmount: "Total mÃ¦ngde",
        totalBaseAmount: "Total basemÃ¦ngde",
        totalColorantAmount: "Total pastamÃ¦ngde",
        type: "Type",
        ufiCode: "UFI kode",
        ufiThreshold: "UFI tÃ¦rskel",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Enhed",
        units: "Enhed",
        unknown: "Unknown",
        update: "Opdater",
        updated: "Opdateret",
        user: "Bruger",
        value: "VÃ¦rdi",
        vat: "Moms",
        verified: "Verified",
        version: "Version",
        versionId: "Versions ID",
        versionStructure: "Versions struktur",
        volumetric: "Volumetrisk",
        warning: "Advarsel",
        warningLevel: "Advarsels niveau",
        withoutName: "(uden navn)",
        workingProperly: "Working properly",
        yes: "Ja",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Indstil denne autotask til at have %{name} anmode om, at rengÃ¸re bÃ¸rstebeholderen pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren skal fjerne, rengÃ¸re og derefter returnere bÃ¸rstebeholderen manuelt.",
            capMaintenance:
                "Indstil denne autotask til at have %{name} anmode om rengÃ¸ring af hÃ¦tten pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren skal rengÃ¸re autocapen manuelt, nÃ¥r den Ã¥bnes.",
            cleanAll:
                "Indstil denne autotask til at fÃ¥ dispenseren til at udfÃ¸re automatisk rengÃ¸ring af alle kanaler pÃ¥ det bestemt tidspunkt.",
            cleanChannels:
                "Indstil denne autotask til at fÃ¥ dispenseren til automatisk at udfÃ¸re rengÃ¸ring af bestemte kanaler pÃ¥ det a bestemt tidspunkt.",
            computerReboot:
                "Indstil denne autotask til at fÃ¥ computeren genstartet automatisk pÃ¥ et bestemt tidspunkt.",
            computerShutdown:
                "Indstil denne autotask til automatisk at slÃ¥ computeren fra pÃ¥ defineretidstidstidsindstillingerne.",
            dispenserCleaning:
                "Indstil denne autotask til at have %{name} anmode om rengÃ¸ring af dispenseren pÃ¥ det bestemt tidspunkt. DispenseroperatÃ¸ren skal rengÃ¸re maskinen med en klud manuelt.",
            humidifierWaterLevelMaintenance:
                "Indstil denne autotask til at have %{name} anmode om genopfyldning af luftfugteren pÃ¥ det bestemt tidspunkt. DispenseroperatÃ¸ren skal kontrollere og genopfylde vandet i luftfugteren manuelt.",
            purgeAll: "Indstil denne autotask til at fÃ¥ dispenseren til at rense alle kanaler pÃ¥ et bestemt tidspunkt.",
            purgeChannels:
                "Indstil denne autotask til at fÃ¥ dispenseren til at rense bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            recirculateAll:
                "Indstil denne autotask til at fÃ¥ dispenseren til at udfÃ¸re recirkulering af alle kanaler pÃ¥ et bestemt tidspunkt.",
            recirculateChannels:
                "Indstil denne autotask til at fÃ¥ dispenseren til at udfÃ¸re recirkulering af bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            refillAll:
                "Indstil denne autotask til at fÃ¥ %{name} til at anmode om handling for automatisk at genopfylde alle rÃ¸r pÃ¥ det definerede tidspunkt. Tonemaskinen skal have pasta genopfyldt i alle beholdere manuelt .",
            refillCanisters:
                "Indstil denne autotask til at fÃ¥ %{name} til at anmode om handling for automatisk pÃ¥fyldning af bestemte rÃ¸r pÃ¥ det definerede tidspunkt. Tonemaskinens operatÃ¸r skal manuelt genopfylde pasta i beholdere, der ikke opfylder genopfyldningskriteriet.",
            smartPurgeAll:
                "Indstil denne autotask til at fÃ¥ dispenseren til automatisk at udfÃ¸re smart udrensnings af alle kanaler pÃ¥ et bestemt tidspunkt. Udrensningen vil blive udfÃ¸rt, medmindre reglerne for Smart-udrensning er opfyldt.",
            smartPurgeChannels:
                "Indstil denne autotask til at fÃ¥ dispenseren til automatisk at udfÃ¸re smart udrensnings af specifikke kanaler pÃ¥ et bestemt tidspunkt. Udrensningen vil blive udfÃ¸rt, medmindre reglerne for Smart-udrensning er opfyldt.",
            stirAll:
                "Indstil denne autotask til at fÃ¥ dispenseren til at udfÃ¸re omrÃ¸ring af alle kanaler pÃ¥ et bestemt tidspunkt.",
            stirCanisters:
                "Indstil denne autotask til at fÃ¥ dispenseren til at udfÃ¸re omrÃ¸ring af bestemte kanaler pÃ¥ et bestemt tidspunkt.",
            switchPlateMaintenance:
                "Indstil denne autotask til at have %{name} anmoder om rengÃ¸ring af switch-pladen pÃ¥ et bestemt tidspunkt. DispenseroperatÃ¸ren skal fjerne, rengÃ¸re og derefter returnere kontaktpladen manuelt."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Tillad at tilfÃ¸je en ny server manuelt, hvis den ikke kan opspores gennem opdagefunktionen.",
            clientIdentifier:
                "Denne indstilling gÃ¸r det muligt at identificere denne klient, hvis der er flere klienter, der er forbundet til en server.",
            disconnect:
                "Oplysninger om den aktuelt anvendte server. Frakoblingsknappen tillader at forlade denne server og skifte til en anden, hvis den er tilgÃ¦ngelig.",
            discover: "Find ud af om der er andre servere tilgÃ¦ngelige i dette netvÃ¦rk.",
            dropServers: "Slet alle tidligere fundne servere fra denne liste.",
            dropServersNotAvailable: "Der er ingen tilgÃ¦ngelig server",
            edit: "Tillad manuel redigering i en allerede funden server.",
            editDisabled: "Der er ikke valgt en server."
        },
        continue: "Vil du virkelig fortsÃ¦tte?",
        driverSettings: {
            alfaRestApi: {
                host: "Indtast computerens vÃ¦rtsnavn eller dens IP adresse.",
                machineType: "GÃ¦lder for alle Alfa-maskiner. Windows sÃ¥vel som Linux."
            },
            corobDsProxy: {
                machineType:
                    "Gyldigt i generationer Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). DspProxy skal vÃ¦re installeret. Kun Windows."
            },
            corobEvoDriver: {
                machineType:
                    "Gyldig til generation 5G (EvoFlx). EVOservice skal vÃ¦re installeret. Windows sÃ¥vel som Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "VÃ¦lg tonemaskinekonfigurationsfilen. Standardindstilling.",
                hldRootDir: "VÃ¦lg hovedmappen for HLD. Standardindstilling.",
                machineType:
                    "GÃ¦lder for Corob Flex (500, 520, 540) = tidligere Lenteq. HLD skal vÃ¦re installeret. Kun i Windows."
            },
            corobNextDriver: {
                machineType:
                    "Gyldigt i generationer Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). NextDriver skal vÃ¦re installeret. Kun Linux."
            },
            dromontDDrv: {
                databasePath: "Sti til databasefilen med kalibreringsdata. Standardindstilling.",
                driverPath: "Sti til driveren (D_DRV.exe). Standardindstilling.",
                machineType:
                    "Indirekte dispenserkommunikation via indstillede stier. GÃ¦lder i generationer V1 og V2. D_SET skal vÃ¦re installeret. Windows sÃ¥vel som Linux.",
                resultPath: "Sti til resultatfilen oprettet efter operationen er forbi. Standardindstilling.",
                serviceSoftwarePath: "Sti til Dromont-servicesoftwaren (D_SET.exe). Defalut forindstillet."
            },
            dromontDirect: {
                machineType:
                    "Direkte dispenser kommunikation. GÃ¦lder i generationer V1 og V2. D_SET skal vÃ¦re installeret. Windows sÃ¥vel som Linux.",
                rootDir: "VÃ¦lg hovedmappen Dromont, standardindstillet."
            },
            dromontMisura: {
                driverPath:
                    "Sti til driveren (MisuraRetail.exe) kan muligvis Ã¦ndres baseret pÃ¥ Misura Retail-versionen. Standardindstilling.",
                extensionPath: "Sti til kommunikationsfil til servicehandlinger.",
                formulaPath: "Sti til kommunikationsfil for toning.",
                machineType: "Gyldig til generation V3. Dromont Misura skal vÃ¦re installeret. Kun Windows."
            },
            fastAndFluidIDD: {
                machineType: "GÃ¦lder for alle F & F-maskiner. Kun Windows.",
                path: "UnderstÃ¸ttes er IDD2 (HA 450, HA 650, X-smart osv.) - skal vÃ¦re licenseret, IDD3 (HP 500 osv.), IDD4 (HA 180, HA 480, HA 680, Xprotint osv.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "GÃ¦lder for alle F & F-maskiner. Windows sÃ¥vel som Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "GÃ¦lder for alle Hero-maskiner. Kun Windows."
            },
            italtinto: {
                machineType:
                    "GÃ¦lder for alle Italtinto-maskiner. Wcal eller ItaltintoCal skal vÃ¦re installeret. Kun Windows.",
                path: "Sti til den justerede Italtinto-konfigurationsfil."
            },
            manualAdvanced: {
                machineType: "GÃ¦lder for alle manuelle maskiner, kanister support inkluderet. Windows sÃ¥vel som Linux.",
                path: "Sti til konfigurationsfilen med data om toningsmaskinen og beholderne."
            },
            manualSimple: {
                machineType: "GÃ¦lder for alle manuelle maskiner. Windows sÃ¥vel som Linux.",
                path: "Sti til konfigurationsfilen med data om toningsmaskinerne."
            },
            none: {
                machineType: "Der er ikke valgt nogen dispenserdriver."
            },
            santintColorLink3: {
                machineType: "GÃ¦lder for alle Santint-maskiner. Kun Windows."
            },
            simulation: {
                machineType:
                    "Gyldig til simulering af tonemaskine, hvis der ikke er nogen reel tonemaskine tilsluttet computeren.",
                path: "Sti til simuleringskonfigurationsfilen, der skal vÃ¦re i overensstemmelse med den indsatte database."
            },
            udcp: {
                machineType: "UDCP tonemaskine"
            }
        },
        environment: {
            activeServerPlugins: "Oversigten over yderligere softwareplugins.",
            allowAutoCloseTab:
                "NÃ¥r indstillingen er aktiveret, lukkes hver receptfane automatisk, nÃ¥r doseringsprocessen er afsluttet.",
            allowAutomaticClientStart:
                "NÃ¥r denne indstilling er aktiveret, starter %{name} automatisk efter computerens start.",
            allowAutomaticPrint:
                "Etiketten udskrives automatisk. KrÃ¦ver yderligere indstilling af udskrivning inden toning, efter toning eller begge dele.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "PÃ¥ receptpanelet vil kundesektionen vÃ¦re tilgÃ¦ngelig.",
            allowDispensing:
                "PÃ¥ receptpanelet aktiveres tone-knappen sammen med tonemaskineindstillinger i Maskinindstillinger.",
            allowFileTransfer:
                "NÃ¥r denne indstilling er aktiveret, er automatisk dataimport og eksport ved filoverfÃ¸rsel tilgÃ¦ngelig.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "Statuspanelet aktiveres pÃ¥ formelpanelet.",
            allowLight: "%{name} vil blive tilgÃ¦ngelig.",
            allowOrdering: "PÃ¥ receptpanelet aktiveres ordreknappen.",
            allowPricing:
                "PÃ¥ receptpanelet kan priserne bruges. Prisernes synlighed er angivet i tilgÃ¦ngelige priser. Priserne er indstillet i Prisindstillinger.",
            allowProductPreviewImage: "Produktbilledet vil blive vist imens der tones",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors:
                "PÃ¥ formelpanelet vil funktionen til at sÃ¸ge efter billigere farver vÃ¦re tilgÃ¦ngelig.",
            allowSoundNotification: "Ordre underretning. Der spilles musikalsk melodi, nÃ¥r en ordre modtages.",
            allowSpectro: "Spektrometer",
            allowTabs: "NÃ¥r denne indstilling er aktiveret, er det muligt at arbejde med flere faner samtidigt.",
            applyZoom: "Zoom forstÃ¸rrer eller reducerer oplÃ¸sningen. Tastaturgenveje CTRL + og CTRL - gÃ¦lder ogsÃ¥.",
            automaticLogout: "Indstil efter hvor mange minutter den automatiske log ud skal aktiveres.",
            availableDatabases:
                "Indstillingerne gÃ¸r det muligt at skifte mellem databaser, hvis der er mere end en tilgÃ¦ngelig.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Stregkodetest bruges til at kontrollere rigtigheden af den scannede stregkode ved at sammenligne den med stregkoderne, der er indsat i databasen.",
            customBanner: "Indstil dit eget logo eller banner og dets placering.",
            customCurrencyFormat:
                "Brugerdefineret valutaformat kan tilsidesÃ¦tte standardvalutaformatet baseret pÃ¥ det valgte sprog.",
            customDateFormat: "Brugerdefineret datoformat kan tilsidesÃ¦tte standard datoformat baseret pÃ¥ valgt sprog.",
            customNumberFormat:
                "Brugerdefineret talformat kan tilsidesÃ¦tte standardnummerformat baseret pÃ¥ valgt sprog.",
            customTimeFormat:
                "Brugerdefineret tidsformat kan tilsidesÃ¦tte standardtidsformatet baseret pÃ¥ valgt sprog.",
            defaultPrinter:
                "Den valgte printer bruges, nÃ¥r du udskriver etiketter, medmindre dette Ã¦ndres i vinduet Printerindstillinger.",
            defaultTemplate:
                "Den valgte skabelon bruges, nÃ¥r du udskriver etiketter, medmindre dette Ã¦ndres i vinduet Printerindstillinger.",
            deleteImportedData:
                "Slet de tidligere importerede specialfremstillede data. Dataene kan importeres igen efter sletning.",
            diskSpaceNotification:
                "Kontrollerer den ledige diskplads og giver besked i tilfÃ¦lde af utilstrÃ¦kkelig diskplads.",
            dispensingNotes: "PÃ¥ receptpanelet er afsnittet om toningsnotater tilgÃ¦ngeligt.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "I %{name} er det virtuelle tastatur tilgÃ¦ngeligt.",
            exportLocalSettings: "Eksporterer de lokale indstillinger pÃ¥ denne computer.",
            exportStaticSql:
                "Eksporterer de lokale indstillinger pÃ¥ denne computer. Den eksporterede fil kan bruges til at oprette en database med de samme indstillinger.",
            exportTranslationKeys:
                "Eksporter de nyeste oversÃ¦ttelser, og efter oversÃ¦ttelsen send dem pÃ¥ e-mail til din softwareleverandÃ¸r for at fÃ¥ dem importeret.",
            favoriteButton: "Klik her for at tilfÃ¸je recept som favorit",
            formulaNotes: "PÃ¥ receptpanelet er sektionen med receptsnotater tilgÃ¦ngelig.",
            helpSettings: "Oplysningerne er synlige i HjÃ¦lp-sektionen pÃ¥ panelet med hurtig adgang.",
            importCustomData: "Importerer den lokale specialfremstillet data baseret pÃ¥ det valgte format.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importerer de lokale indstillinger pÃ¥ denne computer.",
            internalNote: "PÃ¥ formelpanelet vil den intern notesektion vÃ¦re tilgÃ¦ngelig.",
            lockComputer:
                "Indstillingerne sikrer, at omgivelserne for %{name} ikke kan forlades - det giver den ultimative oplevelse af programmet i fuld skÃ¦rm. Kun gÃ¦ldende for Windows.",
            maxNumberTabs: "FanebegrÃ¦nsning angiver, hvor mange receptsfaner, der kan Ã¥bnes simulÃ¦rt.",
            memoryTabs: "Tillad genÃ¥bning af nyligt Ã¥bnede faner, efter at softwaren starter.",
            printAfterDispensing:
                "Indstillingen krÃ¦ver information om, hvor mange etikettekopier, der skal udskrives efter toningsprocessen.",
            printAsImage:
                "Udskriv som billede hjÃ¦lper med at lÃ¸se problemerne, nÃ¥r standardudskrivning mislykkes. Brug ikke det, nÃ¥r standardudskrivning fungerer korrekt. Kun kompatibel med Linux.",
            printBeforeDispensing:
                "Indstillingen krÃ¦ver information om, hvor mange etikettekopier, der skal udskrives inden toningsprocessen.",
            printEnabled:
                "Denne indstilling gÃ¸r det muligt at bruge printeren sammen med softwaren. Yderligere indstillinger findes i Udskrivningsindstillinger.",
            printOnRequest: "PÃ¥ receptpanelet aktiveres udskrivningsknappen.",
            printTaskVariable: "Printopgaven behandles kun, hvis en given printvariabel er tilgÃ¦ngelig i printdata",
            quickTintTemplate: "Den valgte skabelon bruges, nÃ¥r du udskriver hurtige toneetiketter.",
            restoreLocalSettings: "Gendanner de lokale indstillinger pÃ¥ denne computer.",
            runLightAtStartUp: "%{light} startes i stedet for %{name}.",
            screenSaverTimeout: "Indstil timeout for pauseskÃ¦rm",
            selectCustomDataFormat:
                "VÃ¦lg formatet for de originale data, der skal importeres. Hvert format krÃ¦ver muligvis forskellige ekstra filer og indstillinger.",
            setCustomHomeButton: "Hjem-knappen i %{name} omdirigerer til det valgte panel.",
            setFts: "Heltekst-sÃ¸gning muliggÃ¸r sÃ¸gning i fuld tekst recepter (ogsÃ¥ fra midten af ordet osv.).",
            setKeyboardShortcuts:
                "Det er ikke muligt at indstille den samme tastaturgenvej til to forskellige handlinger.",
            setNumberOfDecimalPlaces:
                "Afrunding angiver, hvor mange decimaler tonepastaen, der bruges i recepterne, vises med.",
            setOrderSearchParameters:
                "OrdensÃ¸gning definerer, hvilke parametre der skal bruges, nÃ¥r man sÃ¸ger blandt ordrer. Kun tilgÃ¦ngelig i %{name}.",
            setOverwriteLastTab:
                "NÃ¥r du vÃ¦lger en ny recept via global sÃ¸gning, nÃ¥r recepts-fanebegrÃ¦nsningen er nÃ¥et, overskrives den sidst indlÃ¦ste recepts-fane af den nye valgte recept.",
            setSearchPanel:
                "Angiv din egen synlighed og rÃ¦kkefÃ¸lge pÃ¥ de elementer, der skal bruges, nÃ¥r du sÃ¸ger efter en ny recept.",
            setVisibilityAndOrder:
                "De valgte navigationselementer er synlige i panelet med hurtig adgang. Den hÃ¸jeste position definerer her den venstre position i panelet. Den maksimale tilladte mÃ¦ngde navigationselementer er 6.",
            setYourLanguage: "SprogÃ¦ndring krÃ¦ver genstart af software.",
            settingsSearch: "SlÃ¥ forskellige indstillinger op hvis du er usikker pÃ¥, hvor du kan finde dem.",
            showNewOrderNotifications: "Ordremelding er et pop-up-vindue, der meddeler, at en ny ordre er modtaget.",
            sorting:
                "Hurtigtoning kan bestilles i beholderne i henhold til tonepasta navne eller efter kanister-id'er.",
            turnOnKioskMode: "Fuld skÃ¦rm er pÃ¥ og skjuler proceslinjen.",
            windowClosingRules:
                "Indstillingen bestemmer, om vinduet med hurtigtoning lukkes fÃ¸r eller efter begyndelsen af toningsprocessen."
        },
        formulaSettings: {
            additionalFormulaTab:
                "Indstillingen bestemmer, hvilket panel vil blive vist nÃ¥r der Ã¥bnes en ny receptfane.",
            allowCustomFormulas: "Fremstilling og sÃ¸gning efter specialfremstillede recepter vil blive aktiveret.",
            allowCustomPackageSize: "PÃ¥ receptpanelet vil specialfremstillede pakkestÃ¸rrelser blive aktiveret.",
            allowEditingColorants:
                "PÃ¥ receptpanelet vil redigering af tonepasta knappen blive aktiveret (Synlig efter valg af farve).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Indstil base stÃ¸rrelse pÃ¥ formelpanelet",
            bippPanelSize: "Indstil base stÃ¸rrelse i produktet pÃ¥ formelpanelet",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "PÃ¥ receptpanelet vil den eneste synlige information vÃ¦re farveeksemplet.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "PÃ¥ formelpanelet vil farvepreviewer reprÃ¦senteres med billede.",
            colorPreviewResizable: "GÃ¸r det muligt at Ã¦ndre stÃ¸rrelsen pÃ¥ farvevisningspanelet.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formelpanelet kan fÃ¥ pasta bestilt i henhold til navnene eller efter mÃ¦ngder.",
            customCanOption:
                "VÃ¦lg, hvilke mÃ¥leenheder der kan bruges i det tilpassede produktstÃ¸rrelse pÃ¥ formelpanelet.",
            customCanSettingsUnit:
                "VÃ¦lg, hvilken mÃ¥leenhed der kan bruges som standard til brugerdefinerede produktindstillinger pÃ¥ formelpanelet.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Aktivering af denne indstilling fÃ¸rer til, at pop op-vinduer bekrÃ¦fter sletning af et element.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Indstil farvekortets stÃ¸rrelse pÃ¥ formelpanelet",
            favoriteFormulasInitial: "NÃ¥r du starter %{name}, vises favorit panelet.",
            formulaAutomaticNaming:
                "En Ã¦ndret recept navngives automatisk baseret pÃ¥ de udfÃ¸rte tonepastamodifikationer.",
            formulaPanel: "NÃ¥r du Ã¥bner en ny fane, vises receptpanelet.",
            formulaPanelInitial: "NÃ¥r du starter %{name}, vises receptpanelet.",
            formulaPanelSize: "Indstil formelens stÃ¸rrelse pÃ¥ formelpanelet",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "NÃ¥r denne indstilling er aktiveret, genereres farvevisninger automatisk. Den resulterende forhÃ¥ndsvisning vil ikke vÃ¦re nÃ¸jagtig.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "PÃ¥ receptpanelet vil produktbilledet vÃ¦re synligt ved siden af farveeksempelet med mulighed for at Ã¥bne panelet med mere info.",
            images: "Indstillingen definerer kilden til billedfiler.",
            infoPanelResizable: "GÃ¸r det muligt at Ã¦ndre stÃ¸rrelsen pÃ¥ mere infopanel.",
            initialFormulaTab: "Indstillingen bestemmer, hvilket panel der vises, nÃ¥r %{0} starter.",
            moreInfo:
                "PÃ¥ receptpanelet vil informationspanelet vÃ¦re synligt ved siden af farveeksempel og produktbillede.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Indstillingen gÃ¸r det muligt at bruge produktkoder sammen med produktnavne, hvis informationerne er tilgÃ¦ngelige i databasen.",
            productFiles: "Indstillingen definerer kilden til produktfiler, der er tilgÃ¦ngelige pÃ¥ formelpanelet.",
            productGroups:
                "Indstillingen muliggÃ¸r hierarki som en funktion af produktgrupper, hvis den er tilgÃ¦ngelig i databasen.",
            productPanelSize: "Indstil produktets stÃ¸rrelse pÃ¥ formelpanelet",
            searchNewFormula:
                "NÃ¥r du Ã¥bner en ny fane, vises SÃ¸g efter recept (indeholder oplysninger om sidst tonede recept og favorit recepter).",
            searchNewFormulaInitial:
                "NÃ¥r du starter %{name}, vises SÃ¸g efter recept (indeholder oplysninger om sidst tonede recept og favorit recepter).",
            searchPanelFormulaItems: "Mindst et af formelelementerne skal vÃ¦lges.",
            searchPanelProductItems: "Der kan kun vÃ¦lges et af produktelementerne.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview: "PÃ¥ receptpanelet vil den valgte datatype altid vÃ¦re synlig i farveeksemplet.",
            setFormulaPreview:
                "Indstillingen Ã¦ndrer placeringen og visningen af farveeksempel, pakkebillede og infodata om farven.",
            setFormulaRGBPreviewVisibleInformation:
                "PÃ¥ receptpanelet vil den valgte datatype altid vÃ¦re synlig i farveeksempel.",
            setFormulaUnit:
                "PÃ¥ receptpanelet bestemmer denne indstilling, hvilken farveenhed der skal Ã¥bnes som fÃ¸rst efter valg af en farve. GÃ¦lder ogsÃ¥ i hurtigfarvetone.",
            setFormulaVisibilityAndOrder:
                "PÃ¥ receptpanelet vil de valgte data vÃ¦re synlige i afsnittet Mere info (gÃ¦lder kun, hvis receptseksempel under receptsindstilling er sat til Billede eller Mere info.)",
            setMaxToleranceForCompetitiveColors:
                "Indstil den maksimale Delta E (CIE 2000) tolerance til simulerende farvesÃ¸gning.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "PÃ¥ receptpanelet bestemmer denne indstilling, hvilke tonepastaer der er synlige, nÃ¥r du har valgt en farve. GÃ¦lder ogsÃ¥ i hurtigfarvetone.",
            showColorPreview:
                "PÃ¥ receptpanelet viser smÃ¥ farveeksempel ved siden af farvenavnet, nÃ¥r du sÃ¸ger efter en ny recept.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Summen af pastamÃ¦ngden er under basens grÃ¦nse.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "PastamÃ¦ngden er under den minimale tilladte mÃ¦ngde.",
            dispensingWithErrorsEnabled:
                "Hvis det er tilladt, vises en advarselsmeddelelse i tilfÃ¦lde af overtrÃ¦delser af validering, men det vil vÃ¦re muligt at gÃ¥ videre til udlevering.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Summen af pastamÃ¦ngder overskrider den maksimale tilladte mÃ¦ngde.",
            overfill: "Overfyldning er registreret.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Jeg kender til risici, venligst fortsÃ¦t"
        },
        help: "HjÃ¦lp",
        helpLink: "HjÃ¦lpecentral",
        helper: {
            automaticallyCheckForUpdates:
                "Det kontrolleres automatisk, om der er en opdatering til rÃ¥dighed for %{name} eller database i det givne tidsinterval.",
            automaticallyDownloadUpdates:
                "Hvis en opdatering er tilgÃ¦ngelig, downloades den automatisk uden at skulle bekrÃ¦fte.",
            automaticallyInstallNewDatabases:
                "Hvis der hidtil sendes en fravÃ¦rende DB, installeres den som en ny DB. Bagefter kan DB bruges.",
            automaticallyInstallUpdates:
                "Hvis en opdatering er downloadet, installeres den automatisk uden at skulle bekrÃ¦fte.",
            canBrowseChangeLog: "Ved opdatering af softwaren er den officielle %{name} changelog tilgÃ¦ngelig for at se",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "Opdateringen installeres om natten, hvis computeren kÃ¸rer."
        },
        licensing: {
            collect:
                "Logfilerne downloades til den valgte placering. Logfilerne krÃ¦ves af software leverandÃ¸ren, til at levere fejlanalyse.",
            company: "Det selskab, der leverede licensen.",
            computerID: "Licensidentifikation til at hjÃ¦lpe softwareleverandÃ¸ren i tilfÃ¦lde af pÃ¥krÃ¦vet hjÃ¦lp.",
            email: "Licensindehaverens e-mail-adresse.",
            licenseUuid: "Licensidentifikation til at hjÃ¦lpe softwareleverandÃ¸ren i tilfÃ¦lde af pÃ¥krÃ¦vet hjÃ¦lp.",
            name: "Navnet pÃ¥ licensindehaveren.",
            openBugreport:
                "FortÃ¦l os venligst, om der er en fejl i softwaren, og send os en rapport med fejlbeskrivelsen.",
            posInfoContactperson: "Salgssted oplysninger om ejeren, der skal udskrives pÃ¥ etiketten.",
            posInfoMachineInformation:
                "Salgssted information om dispenseren, der skal udskrives pÃ¥ etiketten eller genkendes i netvÃ¦rket.",
            posInfoPos: "Salgssted oplysninger om det sted, der skal udskrives pÃ¥ etiketten.",
            reactivation: "Genaktivering eller Ã¦ndring af den aktuelle licens.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registreringsoplysninger for at identificere ejeren af licensen.",
            registrationMachineInformation: "Registreringsinformation for at identificere tonemaskinen af licensen.",
            registrationPos: "Registreringsoplysninger for at identificere licensens placering.",
            versionScope: "Softwarens udlÃ¸bsgrÃ¦nser.",
            versionType: "Softwareprodukttypen."
        },
        machineIsBusy: "Der kan ikke nulstilles fejl, da maskinen er optaget.",
        machineSettings: {
            allowManualColorantAddition:
                "Hvis den krÃ¦vede tonepastamÃ¦ngde overstiger den maksimale doseringsmÃ¦ngde, tillader indstillingen at tilfÃ¸je den manuelt efter toningen.",
            autotasks:
                "Autotask er automatiske maskin- og computervedligeholdelsesbegivenheder, der kan indstilles til at blive udfÃ¸rt pÃ¥ et bestemt tidspunkt eller et tidsinterval.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "Stregkoden tildeles den kanister, hvor tonepastaen er tilgÃ¦ngeligt. Stregkoden er nÃ¸dvendig for at sikre korrekt pÃ¥fyldning af tonepasta.",
            checkCanBeforeDispense:
                "Maskinkonfigurationen sammenlignes med databasen hver gang RCC (Redlike Control Center) genstartes. I tilfÃ¦lde af uoverensstemmelser opstÃ¥r der en underretning.",
            checkOverfill:
                "Indstillingen kontrollerer, om der er nok plads i dÃ¥se/spanden til tonepastaerne, fÃ¸r den udleveres.",
            currentlySelectedMachine: "Indeholder information om den aktuelt valgte maskine.",
            dispenseInvalidColorants:
                "Indstillingen gÃ¸r det muligt at dosere tonepastaer, som ikke er defineret i maskinkonfigurationen ved at bede manuel tilfÃ¸jelse af tonepasta.",
            dispenserConfigurationBackup:
                "Download og gem den aktuelle maskinkonfiguration for at opretholde en sikkerhedskopi.",
            dispensingLogic:
                "Dispenseringslogiktyper kan sikre forskellige opfÃ¸rsler for hver kanister, nÃ¥r der er mere tonepasta, der skal udleveres end tilladt eller Ã¸nsket. Ekstra opfÃ¸rsel er indstillet i Dispenseringsindstillinger.",
            enableTmc: "Denne indstilling gÃ¸r det muligt at sende data til TMC.",
            enableUserIdentification: "Brugeren skal logge ind, fÃ¸r toning er tilladt.",
            machineUnit: "Maskinenheden definerer mÃ¥leenheden for tonepastaerne i kanistrene.",
            minDispensedAmount:
                "Minimum doseringsmÃ¦ngde indstiller, hvor meget tonepasta skal have vÃ¦ret doseret for at overveje udrensning gjort (for at undgÃ¥ yderligere udrensning).",
            minimalDispenseAmount:
                "Minimal doseringsmÃ¦ngde er den mindste anbefalede mÃ¦ngde tonepasta, der kan doseres. Hvis den overtrÃ¦des, vises en meddelelse (doseringen er stadig mulig).",
            missingAutotaskCanisters: "Der skal vÃ¦lges mindst 1 kanister",
            missingAutotaskChannels: "Der skal vÃ¦lges mindst 1 kanal",
            missingAutotaskChannelsValue: "Volumen for alle valgte kanaler skal udfyldes",
            missingAutotaskCleanTime: "RengÃ¸ringstidspunktet skal udfyldes",
            missingAutotaskName: "Navnet pÃ¥ autotask skal udfyldes",
            missingAutotaskRecirculation: "Tid og hastighed for recirkulation skal udfyldes",
            missingAutotaskStirring: "Tid og hastighed for omrÃ¸ring skal udfyldes",
            missingAutotaskVolume: "Udrensningsvolumen skal udfyldes",
            placeCanSensor:
                "Indstillingen aktiverer sensor til dÃ¥seplacering - toningen starter ikke, medmindre dÃ¥sen/spanden er placeret korrekt.",
            placeCanSensorDelay:
                "Anbefalet indstilling, der er knyttet til sensor. Det sikrer, at doseringen fÃ¸rst starter efter den definerede tidsperiode, hvor dÃ¥sen/spanden er placeret korrekt.",
            purgeVolume:
                "Udrensningsvolumen indstiller hvor meget tonepasta, der udrenses, nÃ¥r der udfÃ¸res smart udrensning.",
            rccUrl: "RCC (Redlike Control Center) er ansvarlig for kommunikationen med tonemaskinen.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Indstillingen aktiverer sensor til dÃ¥seudtagning - toningen betragtes ikke som udfÃ¸rt, medmindre dÃ¥sen er blevet fjernet.",
            removeCanSensorDelay:
                "Anbefalet indstilling, der er knyttet til dÃ¥sefjernelse sensor. Det sikrer, at toningen fÃ¸rst er afsluttet efter den definerede periode, hvor dÃ¥sen er blevet fjernet.",
            skipPlaceCanDialog:
                "NÃ¥r denne indstilling er aktiveret, venter tonemaskinen ikke, nÃ¥r der placeres en dÃ¥se, indtil der trykkes pÃ¥ OK-knappen, men starter toningsprocessen automatisk.",
            skipRemoveCanDialog:
                "NÃ¥r denne indstilling er aktiveret, venter tonemaskinen ikke, nÃ¥r man fjerner en dÃ¥se, indtil der trykkes pÃ¥ OK-knappen, men vil opfange toningsprocessen som afsluttet automatisk.",
            smartPurgeType:
                "Udrensningstypen kan enten kun overveje at dosere eller dosere plus andre udrensningshÃ¦ndelser, nÃ¥r de valideres, hvis der er behov for smart udrensning.",
            splitFormula:
                "Hvis den krÃ¦vede mÃ¦ngde tonepasta overstiger den maksimale doseringsmÃ¦ngde, giver indstillingen mulighed for at dosere en mÃ¦ngde tonepasta, genopfylde beholderen og derefter fortsÃ¦tte med at dosere resten.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Basen skal valideres via stregkode, fÃ¸r toningen er tilladt. Indstillingen sikrer, at den korrekte base bruges.",
            validateColorantsDuringInit:
                "Maskinkonfigurationen sammenlignes med databasen, hver gang RCC genstartes. I tilfÃ¦lde af uoverensstemmelser opstÃ¥r der en meddelelse."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Ãbner et vindue med mulighed for at indtaste stregkoden manuelt.",
            canisterBarcodes:
                "Ãbner et vindue med oversigt over kanistrenes stregkoder og muligheden for at indstille canistre stregkoderne.",
            canisterLevel:
                "Ãbner et vindue med oversigten over kanisterniveauer og muligheden for at indstille kanisterniveauet.",
            canisters:
                "Ãbner et panel med oversigter over kanisterniveauer og muligheden for at indstille kanisterniveau.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Ãbner et panel med mulighed for at sÃ¸ge efter en ny recept i en elektronisk farvekort.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Ãbner et vindue med oversigt over udfÃ¸rte kanisterpÃ¥fyldninger.",
            customFormula: "Ãbner et panel med mulighed for at oprette en ny specialtoning",
            customers: "Ãbner et panel med oversigt over kunder og muligheden for at tilfÃ¸je / redigere / slette dem.",
            dispensingHistory: "Ãbner et panel med oversigt over udfÃ¸rte toninger.",
            favorites: "Ãbner et panel med mulighed for at vÃ¦lge en favorit recepter.",
            help: "Ãbner et vindue med kundeserviceoplysninger, hvis leveret af leverandÃ¸ren.",
            hideItems: "Ãbner et vindue med mulighed for at markere produkter og farvekort som skjulte.",
            historyOfOrders: "GÃ¦lder udelukkende for %{name}, Ã¥bner et panel med oversigten over tonede ordrer.",
            machineReset: "Starter tonemaskine-nulstilling.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Ãbner et panel med oversigten over sendte ordrer.",
            purge: "Ãbner et vindue med mulighed for at indstille canister udrensning.",
            quickTint: "Ãbner et vindue med mulighed for manuel toning.",
            searchFormula: "Ãbner et panel med mulighed for at sÃ¸ge efter en ny recept.",
            spectro: "Ãbner et panel med mulighed for at mÃ¥le med et spektrometer.",
            stir: "Ãbner et vindue med mulighed for at indstille beholderens omrÃ¸ring.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Ãbner et panel med oversigten over modtagede ordrer."
        },
        noHelpForLicense: "Der er ingen hjÃ¦lp tilgÃ¦ngelig til din licens, bed din leverandÃ¸r om at tilfÃ¸je det.",
        posInfo: {
            sync: "Synkroniserer data med afsnittet Registrering"
        },
        poweredByDeso: "Drevet af %{name}",
        priceSettings: {
            VatPrice: "MomsvÃ¦rdi for tonepasta i %.",
            VatPriceProduct: "Produktmomsen vil vÃ¦re den samme for alle tonepastaer. Sat i %.",
            basePurchase: "KÃ¸bspris for base (inkl. Base udelukkende).",
            basePurchasePriceProduct: "KÃ¸bsprisen for produktet i den givne base. Angivet i den valgte valuta.",
            baseSell: "Salgsprisen kun for base (inkl. Base og profit (margin)/Ã¸nskede profitprocent (markup).",
            baseSellFull: "Sell full price for base.",
            cntName: "Definerer hvilken tonepasta prisen er relateret til.",
            cntPurchase: "KÃ¸bspris for tonepastaer (inkl. Tonepastaer udelukkende).",
            cntPurchaseByName: "KÃ¸bspris for tonepastaer beregnet individuelt for hver (inkl. Tonepasta udelukkende).",
            cntPurchasePricePerLiter:
                "Fremstillingspris for tonepasta pr. Liter (uden profit (margin) eller Ã¸nskede profit procent (markup)).",
            cntSell:
                "Salgsprisen kun for tonepasta (inkl. tonepastaer og profit (margin)/Ã¸nskede profit procent (markup)).",
            cntSellByName:
                "Salgsprisen for alle de anvendte tonepastaer beregnet individuelt for hver (inkl. tonepasta og profit (margin)/Ã¸nskede profit procent (markup)).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "Salgsprisen for pasta per liter (inkl. pasta udelukkende). Sat for den valgte valuta.",
            cntVat: "Tonepastamoms angivet i %.",
            colorants:
                "De generelle priser for tonepasta er de samme for alle tonepastaer. Denne funktion er isÃ¦r nyttig til indstilling af moms.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Valutakode skal vÃ¦re i den officielle trÃ¦bogstavsformular, for eksempel EUR.",
            currencyNameNew: "Navnet pÃ¥ valutaen, for eksempel Euro.",
            currencyRateNew:
                "Valutakursen mod hovedvalutaen, for eksempel 25.855 CZK for 1 â¬. Satsen skal redigeres lÃ¸bende for at blive opdateret.",
            currencyRoundingNew:
                "Afrunding indstiller den mindste mulige vÃ¦rdi af valutaen, for eksempel har Euro afrunding 0,01, fordi den mindste mulige vÃ¦rdi er 1 cent.",
            currencySymbolNew: "Det officielle symbol pÃ¥ valutaen, for eksempel â¬ for Euro.",
            defaultPrice: "Tonepasta pris angivet i den valgte database (uden moms).",
            defaultPriceGroup: "Tonepasta pris for prisgruppe indstillet i den valgte database (uden moms).",
            defaultVatPrice: "Moms for tonepasta angivet i den valgte database.",
            discountHeader: "Rabatten trÃ¦kker den definerede vÃ¦rdi fra kÃ¸bsprisen pÃ¥ tonepasta. Angivet i %.",
            discountHeaderProduct: "Rabatten trÃ¦kker den definerede vÃ¦rdi fra tonepasta prisen. Angivet i %.",
            export: "Eksporter en fil med de aktuelt indsatte priser. Den kan importeres igen efter at have Ã¦ndret priserne.",
            import: "Importer en korrekt formateret (eksporteret) fil for at indsÃ¦tte eller Ã¦ndre priserne.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "VÃ¦lg, hvilken prisberegning der skal anvendes til definitionen af den endelige pris. Margin og markup tilfÃ¸jes mens rabatten trÃ¦kkes fra den givne salgspris.",
            marginAll:
                "Prisen for profit (margin)/Ã¸nskede profit procent (markup) for flere pakker (inkl. Margin / markup).",
            marginHeader: "Margin lÃ¦gger den definerede vÃ¦rdi til kÃ¸bprisen for tonepasta. Angivet i %.",
            marginHeaderProduct: "Margin lÃ¦gger den definerede vÃ¦rdi til kÃ¸bsprisen for produktet. Angivet i %.",
            marginPerPkg:
                "Prisen for profit (margin)/Ã¸nskede profit procent (markup) for en pakke (inkl. Margin / markup).",
            markupHeader: "Markup lÃ¦gger den definerede vÃ¦rdi til kÃ¸bsprisen for tonepasta. Angivet i %.",
            markupHeaderProduct: "Markup lÃ¦gger den definerede vÃ¦rdi til kÃ¸bsprisen or produktet. Angivet i %.",
            packagePricing: "Ekstra tillÃ¦g angivet individuelt for hver pakke stÃ¸rrelse.",
            packageSurcharge: "De generelle pakkepriser er de samme for hvert pakketillÃ¦g.",
            priceDefinition: "Indstillingen definerer, hvilke pristyper der bruges ved beregning af endelige priser.",
            priceGroupNumber:
                '"Indstillingen definerer, hvor mange prisgrupper der vil blive brugt. Intervallet for individuelle prisgrupper kan indstilles under ""StandardvÃ¦rdier""."',
            priceGroupPricePerLiter: "Tonepastaprisen, der anvendes til beregning af prisgruppeprisen.",
            priceGroups:
                "Prisgrupper viser nummeret pÃ¥ den relevante prisgruppe (grÃ¦nserne er angivet i databasen eller i generel prisfastsÃ¦ttelse).",
            priceGroupsEnabled:
                '"Indstillingen giver dig mulighed for at arbejde med prisgrupper. Definer intervallet i ""StandardvÃ¦rdier"" og individuelle priser i ""Pasta PrissÃ¦tning""."',
            priceGroupsGeneric:
                "Prisgrupper er prisintervaller for den endelige maling baseret pÃ¥ tonepastaen i recepten.",
            productBasePackageSellPrice: "Salgspris for produkt af den givne base. Sat for den valgte valuta.",
            productBaseSellPrice:
                "Salgspris for base beregnet pr. liter (inkl. base eksklusiv). Sat for den valgte valuta.",
            productBaseVat: "MomsvÃ¦rdien for den givne pakke, er angivet i %.",
            productName: "Definerer, hvilken base af hvilket produkt prisen er relateret til.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "KÃ¸bsprisen for alle pakker bruges ved dispensering af brugerdefinerede pakker.",
            productSize: "Definerer, hvilken pakke af den angivne base og produkt prisen er relateret til.",
            productVat: "Moms for denne produktbase angivet i %.",
            products:
                "De generelle produktpriser er de samme for hvert produkt. Denne funktion er isÃ¦r nyttig til indstilling af moms.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "Salgsprisen for flere pakker (inkl. Base, tonepasta, tillÃ¦g og profit (margin)/Ã¸nskede profit procent (markup)).",
            sellPricePerKg:
                "Produktets salgspris pr. Kg (inkl. Base, tonepasta, tillÃ¦g og profit (margin)/Ã¸nskede profit procent (markup)).",
            sellPricePerL:
                "Produktets salgspris pr. Liter (inkl. Base, tonepasta, tillÃ¦g og profit (margin)/Ã¸nskede profit procent (markup)).",
            sellPricePerPkg:
                "Salgsprisen for en pakke (inkl. Base, tonepasta, tillÃ¦g og profit (margin)/Ã¸nskede profit procent (markup)).",
            setPriceTypesVisibilityAndOrder:
                "I formelpanelet vil de valgte priser vÃ¦re synlige i afsnittet om priser. Den hÃ¸jeste position her definerer positionen lÃ¦ngst til venstre i sektionen.",
            surchargeAll: "Prisen pÃ¥ et tillÃ¦gsgebyr for flere pakker (inkl. TillÃ¦g).",
            surchargePerPkg: "Prisen pÃ¥ et tillÃ¦gsgebyr for en pakke (inkl. TillÃ¦g).",
            tintPurchaseAll: "KÃ¸bsprisen for hele toningsprocessen for flere pakker (inkl. tonepasta og tillÃ¦g).",
            tintPurchasePerPkg: "KÃ¸bsprisen for hele toningsprocessen for en pakke (inkl. Tonepasta og tillÃ¦g).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "Den samlede kÃ¸bspris for produktet for flere pakker (inkl. Base og tonepastaer).",
            totalPurchasePerKg: "Den samlede kÃ¸bspris for produktet pr. Kg (inkl. Base og tonepastaer).",
            totalPurchasePerL: "Den samlede kÃ¸bspris for produktet pr. liter (inkl. Base og tonepastaer).",
            totalPurchasePerPkg: "Den samlede kÃ¸bspris for produktet for en pakke (inkl. Base og tonepastaer).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "PÃ¥ receptpanelet vil prisen vÃ¦re synlig i begge variationer, med og uden moms, samtidigt.",
            withVat: "PÃ¥ receptpanelet er alle priser kun synlige med moms inkluderet.",
            withoutVat: "PÃ¥ receptpanelet vil alle priser kun vÃ¦re synlige eksklusiv moms."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synkroniserer data med afsnittet POS Info"
        },
        searchingPleaseWait: "Vent venligst, der sÃ¸ges efter bedste match",
        setupSteps: {
            customData: "Specialfremstillet data",
            machineType: "Maskintype",
            userPreferences: "BrugerprÃ¦ferencer "
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "NÃ¥r du bruger profilerede vÃ¦rdier, genberegnes de mÃ¥lte resultater for at fjerne filtereffekten. Tillad denne indstilling til universel spektromÃ¥ling.",
            XRiteModelRM400: "Der krÃ¦ves ingen drivere.",
            datacolorDiagnosticTile: "Datafarve bruger diagnostisk flise",
            datacolorSilent: "Datafarve tavs",
            measureModes: "VÃ¦lg understÃ¸ttede glansniveauer.",
            model: "Model",
            simulationPath: "Simulationssti",
            spectroType: "Spektrometer type",
            spectroTypeCom:
                "Officiel spektrodriver skal installeres. Pas pÃ¥ den anvendte COM-port. Windows samt Linux.",
            spectroTypeDataColorReader:
                "Computeren skal have Bluetooth-forbindelse. Spektroen skal parres med computeren. Windows 10 med 2018 automn opdatering pÃ¥krÃ¦vet.",
            spectroTypeMinolta2XXXd:
                "Officiel spektrodriver skal installeres. Pas pÃ¥ den anvendte COM-port. Windows samt Linux.",
            spectroTypeNotSelected: "VÃ¦lg din spektromodel.",
            spectroTypeRM400: "Der krÃ¦ves ingen drivere.",
            spectroTypeSimulation:
                "LaboratorievÃ¦rdier, der krÃ¦ves for at opnÃ¥ simuleringsresultater. Windows samt Linux.",
            spectroTypeXRite: "Kun i Windows."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base spands UFI kode skal valideres via stregkode, fÃ¸r toning kan ske.",
            enableUfiCodes: "UFI koder bruges i EU og giver oplysninger om, hvor farligt et produkt er for miljÃ¸et.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Hvis pastaen i en formel overstiger den givne grÃ¦nse, udskrives dens UFI kode pÃ¥ udskriftsetiketten.",
            printUfiCodePercentage:
                "Hvis pastaen i en formel overstiger den givne grÃ¦nse, udskrives dens UFI kode pÃ¥ udskriftsetiketten sammen med dens procentvise reprÃ¦sentation.",
            ufiCodesByPercentage:
                "Den bestemmende UFI kode bruges til udskrivning i betragtning af dens faktiske mÃ¦ngde i beholderen. Naviger til beholderindstillinger for at definere tÃ¦rsklen for hver beholder.",
            ufiCodesFromDatabase: "UFI koden fra den primÃ¦re database bruges til udskrivning.",
            ufiCodesFromLastFilling:
                "UFI koden fra den sidste pÃ¥fyldning bruges til udskrivning uanset den genfyldte mÃ¦ngde."
        },
        userManagement: {
            add: "Indstillingen tilfÃ¸jer en ny bruger, der kan logge ind pÃ¥ softwaren. Brugeren kan fÃ¥ tildelt en stregkode og kan indstilles til automatisk at logge pÃ¥, efter softwaren er startet.",
            assignedGroups:
                "Dette definerer, hvilke brugergrupper brugeren tilhÃ¸rer. Forskellige brugergrupper indebÃ¦rer forskellige privilegier.",
            availableGroups:
                "Dette definerer, hvilke brugergrupper der er tilgÃ¦ngelige for brugeren. Forskellige brugergrupper indebÃ¦rer forskellige privilegier.",
            loggedUserDelete: "Brugeren, der aktuelt er logget pÃ¥, kan ikke slettes."
        },
        visit: "Eller besÃ¸g",
        visitNoLicense: "For mere information, besÃ¸g venligst"
    },
    helpSettings: {
        customHelpLink: "Kunde hjÃ¦lp-center link",
        helpSettings: "HjÃ¦lpindstillinger",
        message: "Besked"
    },
    helper: {
        automaticallyCheckForUpdates: "Tjek automatisk for opdateringer",
        automaticallyDownloadUpdates: "Download automatisk opdateringer",
        automaticallyInstallNewDatabases: "Installer automatisk nye DBs",
        automaticallyInstallUpdates: "Installer automatisk opdateringer",
        bugReport: "Softwarefejlrapport",
        canBrowseChangeLog: "Vis online %{name} changelog",
        collect: "Indsamle",
        collectLogFiles: "Indsamel Logfiler",
        component: "Komponent",
        content: "Indhold",
        contentSize: "IndholdsstÃ¸rrelse",
        download: "Hent",
        downloadLogFiles: "Download logfiler",
        downloadingData: "Downloader data",
        everyHours: "Hver %{interval} time",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Ny version",
        notConnected: "HjÃ¦lper er ikke forbundet",
        openBugReport: "Ãben fejlrapport",
        packageSize: "PakkestÃ¸rrelse",
        pleaseWait: "Dette kan tage noget tid, vent venligst.",
        send: "Send",
        sendBugReportToCustomerService: "Send fejlrapport",
        sendingReport: "Sender",
        subject: "Emne"
    },
    helperDialog: {
        1: "Du kan kontrollere software- eller databaseopdateringer.",
        2: "Vil du fortsÃ¦tte med at downloade opdateringspakkerne?",
        3: "Vil du fortsÃ¦tte med installationen af downloadede opdateringspakker?",
        10: "Kontrollerer software- og databaseopdateringer, vent venligst ...",
        11: "Der er en opdatering tilgÃ¦ngelig til din computer. Vil du downloade det?",
        12: "Der er ingen tilgÃ¦ngelige opdateringer til din computer.",
        14: "Der opstod en fejl under kontrol af opdateringer. %{0}",
        15: "Synkroniserer zone databaser, vent venligst ...",
        20: "Downloader opdateringspakke, vent venligst ...",
        21: "Opdateringspakke, der blev downloadet, verificeres nu. Vent venligst ...",
        22: "Download af opdateringspakken mislykkedes. Vil du prÃ¸ve igen?",
        23: "Download af opdateringspakken mislykkedes (filen er forkert formet), vil du prÃ¸ve igen?",
        24: "FortsÃ¦tte med opdateringsinstallationen?",
        25: "Installationen af automatisk opdatering starter om %{0}",
        26: "Der er en opdatering tilgÃ¦ngelig til din computer. Vil du downloade det?",
        27: "FortsÃ¦tte med opdateringsinstallationen?",
        40: "Stop af applikationer og tjenester, vent venligst ...",
        41: "Kopierer nye filer, vent venligst ...",
        42: "Start af applikationer og tjenester, vent venligst ...",
        43: "Afslut softwareopdatering, vent venligst ...",
        44: "Din software er blevet opdateret.",
        45: "Vil du prÃ¸ve installationen igen? Hvis du beslutter at prÃ¸ve igen, skal du sikre dig, at softwarekomponenter ikke i Ã¸jeblikket er i brug.",
        46: "Genstart af pc er pÃ¥krÃ¦vet for at pÃ¥virke Ã¦ndringerne, genstart sker i %{0}",
        999: "Intern fejl opstod: %{0}",
        automaticInstallation: "Installation af automatisk opdatering",
        btnAbort: "Afbryd",
        btnCancel: "Annuller",
        btnCheckUpdate: "Tjek efter opdateringer",
        btnContinue: "FortsÃ¦t",
        btnDownloadUpdate: "Download opdatering",
        btnInstallUpdate: "Installer opdatering",
        btnOk: "Okay",
        btnRetry: "PrÃ¸v igen",
        btnSkip: "Spring over",
        checkingForUpdates: "Tjekker efter opdatering",
        downloadingFailed: "Downloading fejlede",
        downloadingPackage: "Downloader opdateret pakke, vent venligst",
        finishingUpdate: "Opdatering er fÃ¦rdig",
        installingUpdate: "Installere opdatering",
        internalError: "Intern fejl",
        rebootRequired: "Genstart krÃ¦ves",
        startingComponents: "Start softwarekomponenter",
        stoppingComponents: "Slut softwarekomponenter",
        synchronizingDatabases: "Synkronisering af databaser",
        updateAvailable: "Opdater tilgÃ¦ngelig, vÃ¦lg komponenter der skal opdateres",
        updateDownloaded: "Opdateringen er blevet downloadet",
        updateFailed: "Opdateringsprocessen er mislykket",
        updateInstalled: "Opdateringen er blevet installeret",
        verificationFailed: "BekrÃ¦ftelse af opdateringspakken mislykkedes",
        verifyingPackage: "BekrÃ¦fter downloadet pakke",
        yourSoftwareIsUpToDate: "Din software er opdateret",
        yourSoftwareVersion: "Din software version: %{0}"
    },
    importData: {
        abortImportingData: "Afbryd import",
        aborted: "Import blev afbrudt",
        backupLocalDB: "Backup local database",
        confirmRestore: "Vil du virkelig gendanne alle lokale indstillinger?",
        dataMissing: "Import mislykkedes, fordi kildefilen ikke indeholdt nogen data.",
        deleteImportedData: "Slet importdata",
        encodingFile: "Filkodning",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Import mislykkedes, fordi kildefilen ser ud til at vÃ¦re beskadiget.",
        fileMissing: "Import mislykkedes, fordi kildefilen ikke eksisterer.",
        format: "Format",
        formatPath: "Formatsti",
        headerMissing: "Import mislykkedes, fordi filoverskriften mangler.",
        import: "Importer",
        importAborted: "Import afbrudt",
        importAborting: "Import afbrydes",
        importFailed: "Import mislykkedes grundet uforudset fejl",
        importLocalSettings: "Import Local Settings",
        importPrices: "Import priser",
        imported: "Succesfuldt importeret",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importerer",
        noFormatAvailable: "Intet format til rÃ¥dighed",
        processing: "Behandler",
        processingCustomFormulas: "Behandler specialtoning",
        processingCustomers: "Behandler kunder",
        productsFile: "Produktfil",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Import er i gang",
        unknownFormat: "Import fejlede da kildefilen Er af ukendt format",
        userFormulasFile: "Brug receptsfiler"
    },
    infoType: {
        baseDensity: "Basens massefylde",
        baseMass: "Basens masse",
        baseUfiCode: "UFI kode for base",
        baseVolume: "Basens volumen",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS grad",
        colorLab: "Farve lab data",
        colorRgb: "Farve RGB",
        colorRgbHex: "Farve RGB Hex",
        colorXyz: "Farve xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Tonepastaens masse",
        colorantUfiCodes: "UFI kode for pasta",
        colorantVolume: "Tonepastaens volumen",
        formulaDate: "Formeldato",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Mere info for formlen",
        formulaMoreInfoInternal: "Intervaler for mere info for formlen",
        formulaMoreInfoPrint: "Mere info for formlen",
        hbw: "HBW",
        isPackageGravimetric: "Er pakken gravimetrisk",
        maxColorantMass: "Maksimal tilladte tonepastamasse",
        maxColorantVolume: "Maksimal tilladte tonepastavolumen",
        nominalMass: "Pakkens nominelle masse",
        nominalVolume: "Pakkens nominelle volumen",
        overfillDetected: "Overfyldning opdaget",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Totale malingsmasse",
        totalPaintVolume: "Totale malingsvolumen",
        ufiCodesTable: "UFI kodertabel",
        verifiedFormula: "BekrÃ¦ft formel",
        yValue: "Y vÃ¦rdi"
    },
    initialTab: {
        favoriteFormulas: "Favorit recepter",
        lastDispensedFormulas: "Sidst tonede recept",
        searchNewFormula: "SÃ¸g efter recept"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "handling",
        add: "tilfÃ¸j",
        addition: "tilfÃ¸jelse",
        additional: "yderligere",
        address: "adresse",
        admin: "admin",
        advanced: "Avanceret",
        after: "efter",
        afterDispensing: "efter dosering",
        alfa: "Alfa",
        all: "alle",
        allow: "tillad",
        alphabetically: "alfabetisk",
        amount: "mÃ¦ngde",
        api: "api",
        ask: "spÃ¸rg",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "tilgÃ¦ngelig pris",
        backup: "backup",
        banner: "banner",
        barcode: "stregkode",
        barcodes: "stregkoder",
        base: "base",
        before: "fÃ¸r",
        begin: "begynde",
        bfs: "BFS",
        bottom: "bund",
        brand: "mÃ¦rke",
        brush: "bÃ¸rste",
        bug: "fejl",
        button: "knap",
        buy: "kÃ¸be",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrering",
        can: "spand",
        canHandling: "spand hÃ¥ndtering",
        canister: "kanister",
        canisterFilling: "kanister pÃ¥fyldning",
        canisterLevels: "kanister niveauer",
        canisters: "kanistre",
        cap: "lÃ¥g",
        center: "Center",
        centre: "Centrum",
        change: "Ã¦ndring",
        changelog: "Changelog",
        channels: "kanaler",
        check: "kontroller",
        chunk: "del",
        chunks: "dele",
        city: "by",
        clean: "ren",
        cleaning: "rengÃ¸ring",
        clientIdentifier: "klient-id",
        close: "tÃ¦t",
        closest: "tÃ¦ttest",
        code: "kode",
        collect: "indsamle",
        color: "farve",
        colorLink3: "ColorLink3",
        colorPanel: "Farvepalette",
        colorReader: "ColorReader",
        colorant: "tonepasta",
        colorantConsumption: "tonepasta forbrug",
        colorantPrice: "tonepastapris",
        colorants: "tonepastaer",
        colorix: "Colorix",
        colour: "farve",
        communication: "kommunikation",
        compare: "sammenligne",
        competitive: "konkurrencedygtige",
        computer: "computer",
        config: "konfigurer",
        configuration: "konfiguration",
        confirm: "bekrÃ¦ft",
        confirmation: "bekrÃ¦ftelse",
        connection: "forbindelse",
        contactPerson: "kontaktperson",
        control: "Kontrol",
        copies: "kopier",
        corob: "Corob",
        cost: "omkostninger",
        country: "land",
        create: "opret",
        currency: "valuta",
        current: "nuvÃ¦rende",
        custom: "Specialfremstillet",
        customers: "kunder",
        daily: "daglig",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "dato",
        decimals: "decimaler",
        default: "standard",
        delay: "forsinkelse",
        delete: "slet",
        deletion: "sletning",
        deltaE: "delta e",
        device: "enhed",
        devices: "enheder",
        diagnosticTile: "diagnosticeringsfelt",
        dialog: "dialog",
        direct: "direkte",
        disconnect: "afbryd",
        discount: "rabat",
        dispense: "doser",
        dispenser: "tonemaskine",
        dispensing: "dosering",
        down: "ned",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "redigere",
        editor: "editor",
        email: "E-mail",
        error: "fejl",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "udlÃ¸b",
        export: "eksport",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "farvekort",
        fastFluid: "Fast & Fluid",
        file: "fil",
        fill: "fyld",
        fillToMax: "fyld til maks.",
        find: "ï¬nd",
        first: "fÃ¸rste",
        flex: "Flex",
        folder: "mappe",
        formula: "recept",
        formulas: "recepter",
        from: "fra",
        fts5: "FTS5",
        fullScreen: "fuld skÃ¦rm",
        fullText: "fuld tekst",
        fulltext: "fuld tekst",
        g: "g",
        genericPricing: "generisk prissÃ¦tning",
        hLD: "HLD",
        hard: "hÃ¥rdt",
        hbw: "hbw",
        help: "hjÃ¦lp",
        helpCenter: "hjÃ¦lpecentral",
        hero: "Hero",
        history: "historik",
        home: "hjem",
        host: "host",
        humidifier: "luftfugter",
        iDD: "IDD",
        identification: "identifikation",
        image: "billede",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "importere",
        individually: "individuelt",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialisering",
        initialize: "initialisere",
        insert: "indsÃ¦tte",
        install: "Installere",
        intellyPurge: "intelly udrensning",
        invalid: "ugyldig",
        ipAddress: "IP-adresse",
        italtinto: "Italtinto",
        items: "genstande",
        keyboard: "tastatur",
        kg: "Kg",
        kiosk: "fuld skÃ¦rm",
        kioskMode: "fuld skÃ¦rms tilstand",
        l: "L",
        lLD: "LLD",
        lab: "Lab",
        label: "label",
        labels: "label",
        language: "sprog",
        largo: "Largo",
        last: "sidste",
        lenteq: "Lenteq",
        levels: "niveauer",
        license: "licens",
        light: "lys",
        limit: "grÃ¦nse",
        link: "link",
        linux: "Linux",
        load: "indlÃ¦se",
        lock: "lÃ¥s",
        logFiles: "logfiler",
        logic: "logik",
        logo: "logo",
        lower: "lavere",
        machine: "maskine",
        machineConfiguration: "konfiguration af maskine",
        machineManagement: "maskinstyring",
        machineName: "maskinenavn",
        main: "primÃ¦re",
        maintenance: "vedligeholdelse",
        manual: "manuel",
        manualAddition: "manuel tilfÃ¸jelse",
        manualDispensing: "manuel dosering",
        manualScan: "manuel scanning",
        margins: "margins",
        markups: "markups",
        mass: "masse",
        match: "match",
        measure: "mÃ¥le",
        measurement: "mÃ¥ling",
        measurementUnits: "mÃ¥leenheder",
        melody: "melodi",
        message: "besked",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutter",
        misura: "Misura",
        ml: "ml",
        mode: "tilstand",
        model: "model",
        modification: "Ã¦ndring",
        modify: "Ã¦ndre",
        monthly: "mÃ¥nedlige",
        moreInfo: "mere information",
        movableTable: "bevÃ¦geligt bord",
        move: "flytte",
        music: "musik",
        myOrders: "mine ordrer",
        name: "navn",
        naming: "navngivning",
        nano: "Nano",
        navigation: "navigation",
        new: "nye",
        nextDriver: "NextDriver",
        night: "nat",
        nixPro: "Nix Pro",
        notes: "noter",
        notification: "notifikation",
        number: "nummer",
        off: "off",
        open: "Ã¥bne",
        order: "bestil",
        ordering: "bestilling",
        overfill: "overfyldning",
        overview: "oversigt",
        overwrite: "overskrive",
        own: "egen",
        pCPDriver: "PCPDriver",
        package: "pakke",
        packagePrice: "pakkepris",
        packages: "pakker",
        panels: "Paneler",
        parameter: "Parameter",
        path: "Sti",
        pc: "Pc",
        phone: "telefon",
        phoneNumber: "telefonnummer",
        picture: "billede",
        place: "placer",
        placement: "placering",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "salgsstedet",
        popUp: "pop-up",
        pos: "POS",
        present: "nuvÃ¦rende",
        preview: "forhÃ¥ndsvisning",
        price: "pris",
        priceExport: "priseksport",
        priceGroup: "prisgruppe",
        priceImport: "prisimport",
        prices: "priser",
        pricing: "prissÃ¦tning",
        primaryCurrency: "primÃ¦r valuta",
        print: "udskriv",
        printer: "printer",
        printing: "udskriver",
        problem: "problem",
        product: "produkt",
        productPrice: "produktpris",
        profiledValues: "profilbestemte vÃ¦rdier",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "udrense",
        purgeType: "udrensningstype",
        purgeVolume: "udrensningsvolumen",
        quality: "kvalitet",
        quick: "hurtig",
        quickTint: "hurtig toning",
        rM: "RM",
        raise: "lÃ¸ft",
        rcc: "RCC",
        reader: "Reader (Colorix Reader Pro)",
        reboot: "genstart",
        receive: "modtag",
        recirculate: "recirkulere",
        recirculation: "recirkulation",
        redlike: "Redlike",
        refill: "genopfyld",
        registration: "registrering",
        regular: "regelmÃ¦ssig",
        removal: "fjernelse",
        remove: "fjern",
        report: "rapport",
        reset: "nulstil",
        resolution: "oplÃ¸sning",
        restart: "genstart",
        rgb: "RGB",
        rights: "rettigheder",
        rounding: "afrunding",
        rules: "regler",
        sanTint: "SanTint",
        save: "gem",
        scale: "skala",
        scan: "skan",
        scope: "omfanget",
        screen: "skÃ¦rm",
        screensaver: "pauseskÃ¦rm",
        search: "sÃ¸g",
        secondaryCurrency: "sekundÃ¦r valuta",
        select: "vÃ¦lg",
        selectedFormula: "Selected formula",
        sell: "sÃ¦lge",
        sensor: "sensor",
        serialNumber: "serienummer",
        server: "server",
        servers: "servere",
        service: "service",
        serviceAction: "servicehandling",
        serviceActions: "servicehandlinger",
        serviceSoftware: "servicesoftware",
        serviceWindow: "servicevindue",
        settings: "indstillinger",
        shelf: "hylde",
        shortcuts: "genveje",
        shot: "shot",
        show: "vis",
        shutDown: "luk ned",
        shutdown: "lukning",
        silent: "stille",
        simple: "simpel",
        simulation: "simulering",
        size: "stÃ¸rrelse",
        skip: "spring over",
        smartPurge: "smart udrensning",
        software: "software",
        softwareSupplier: "softwareleverandÃ¸r",
        sort: "sortere",
        sound: "lyd",
        spectro: "spektro",
        spectrophotometer: "spektrofotometer",
        speed: "hastighed",
        split: "dele",
        start: "start",
        startup: "opstart",
        statistics: "statistik",
        status: "status",
        stir: "rÃ¸r",
        stirring: "omrÃ¸ring",
        street: "gade",
        support: "support",
        surcharge: "tillÃ¦g",
        tab: "fane",
        tabs: "faner",
        task: "opgave",
        template: "skabelon",
        testing: "test",
        time: "tidspunkt",
        tintingManagementCenter: "tinting ledelses center",
        to: "til",
        toDispense: "at dosere",
        tolerance: "tolerance",
        top: "top",
        total: "samlede",
        translation: "oversÃ¦ttelse",
        turnOff: "sluk",
        turntable: "Drejeskive",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "Amerikansk gallon",
        uSQuart: "Amerikansk quart",
        unit: "enhed",
        up: "op",
        update: "opdatering",
        url: "Url",
        user: "bruger",
        userGroups: "brugergrupper",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "moms",
        validate: "validere",
        validation: "validering",
        version: "version",
        virtual: "virtuelle",
        volume: "volumen",
        weekly: "ugentlige",
        window: "vindue",
        windows: "vinduer",
        with: "med",
        without: "uden",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y-vÃ¦rdi",
        zipCode: "postnummer",
        zoom: "zoom"
    },
    languages: {
        bg: "Bulgarsk",
        cs: "Tjekkisk",
        da: "Dansk",
        de: "Tysk",
        el: "GrÃ¦sk",
        en: "Engelsk",
        es: "Spansk",
        fr: "Fransk",
        hr: "Kroatisk",
        hu: "Ungarsk",
        id: "Indonesisk",
        is: "Islandsk",
        it: "Italiensk",
        lt: "Litauisk",
        lv: "Lettisk",
        ms: "Malajisk",
        nl: "Hollandsk",
        no: "Norsk",
        pl: "Polsk",
        pt: "Portugisisk",
        ro: "RumÃ¦nsk",
        ru: "Russisk",
        sk: "Slovakisk",
        sr: "Serbisk",
        sv: "Svensk",
        zh: "Kinesisk"
    },
    license: {
        activateLicense: "AktivÃ©r licens",
        activateNewLicense: "AktivÃ©r ny licens",
        checkLicenseKey: "Tjek licensnÃ¸gle",
        companyId: "Firma ID",
        contactPerson: "Kontaktperson",
        copy: "Kopier",
        country: "Land",
        emptyCity: "By er en pÃ¥krÃ¦vet information",
        emptyCountry: "Land er en pÃ¥krÃ¦vet information",
        emptyName: "Butiksnavn er en pÃ¥krÃ¦vet information",
        enterIdentificationKeys: "Indtast din identifikationsnÃ¸gle",
        expirationDate: "UdlÃ¸bsdato  %{dateTime}",
        fillRegistration: "Udfyld registreringsdata (kÃ¸r ned for at se mere)",
        insertLicense: "IndsÃ¦t genereret nÃ¸gle til offline aktivering",
        invalidEmail: "Den intastede email er ugyldig",
        invalidPhone: "Det intastede telefonnummer er ugyldig",
        itemsMarkedasterisk: "(felter markeret med en stjerne skal udfyldes)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Lejet licens",
        licenseActivated: "Licensen er allerede aktiveret",
        licenseStatus: "Licens status",
        licenseWillExpire: "Din licens udlÃ¸ber om %{dayCount} dage",
        licenseWillExpireOneDay: "Din licens udlÃ¸ber om %{dayCount} dage",
        machineInformation: "Maskine informationer",
        noLicenseAvailable: "Ingen licens tilgÃ¦ngelig",
        noProductsForKey: "Der er ingen produkter tilgÃ¦ngelig for den Ã¥bne identifikationsnÃ¸gle.",
        pointOfSale: "Salgssted",
        producer: "Producent",
        reactivate: "Genaktivere",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "Venligst lav en kopi af aktiveringsanmodning og naviger til:",
        registrationForm: "Registrering",
        selectProduct: "VÃ¦lg produkt",
        serialNumber: "Serienummer",
        skipNewLicense: "Hvis du Ã¸nsker at aktivere ny licens senere, kan du trykke spring over",
        unlimitedLicense: "UbegrÃ¦nset licens",
        userId: "Bruger ID",
        uuid: "Licens UUID",
        versionDetails: "Versions detaljer",
        versionScope: "Versions formÃ¥l",
        versionType: "Versions type",
        zip: "Postnummer"
    },
    login: {
        authenticate: "Godkend",
        logIn: "Login",
        loginAs: "Login som en anden bruger",
        messages: {
            incorrectUsername: "Brugernavn og adgangskode er forkert "
        },
        password: "Adgangskode",
        username: "Brugernavn"
    },
    machineActionHistory: {
        actionHistory: "Handlingshistorik"
    },
    machineErrors: {
        channel: "Kanaler",
        code: "Kode",
        machineErrors: "Maskinefejl",
        noMachineErrors: "Der er i Ã¸jeblikket ingen maskinfejl",
        resetErrors: "Nulstillingsfejl"
    },
    machineSettings: {
        action: "Handling",
        addAutotask: "TilfÃ¸j Autotask",
        autoCanisterIn: "Automatisk kanister ind",
        autoCanisterOut: "Automatisk kanister ud",
        automaticRefill: "Automatisk genopfyldning",
        autotaskSettings: "Autotask indstillinger",
        backupConfiguration: "Toningsmaskine konfiguration sikkerhedskopi",
        brushMaintenance: "BÃ¸rstevedligeholdelse",
        capMaintenance: "Vedligeholdelse af lÃ¥g",
        checkCanisterBeforeDispense: "Tjek kanistre fÃ¸r toning",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Kontroller den minimale tilladte mÃ¦ngde af tonepasta",
        checkOverfill: "Kontroller overfyldning af spand",
        checkTotalCntAmounts: "Kontroller den totale pastamÃ¦ngde for basen",
        cleanAll: "RengÃ¸r alle",
        computerReboot: "Computer genstart",
        computerShutdown: "Computer nedlukning",
        connectMachine: "Forbind maskine",
        days: "Dage",
        daysOfMonth: "Dage om mÃ¥neden",
        devices: "Apparat",
        disabled: "Deaktiveret",
        dispenseAndPurge: "Toning og rens",
        dispenseOnly: "Kun toning",
        dispenserCleaning: "Tonemaskinerensning",
        dispensingWithErrorsEnabled: "Tillad udlevering pÃ¥ trods af valideringsfejl",
        editAutotask: "Rediger Autotask",
        firstRun: "FÃ¸rste gennemlÃ¸b",
        hours: "Timer",
        humidifier: "Luftfugter",
        humidifierWaterLevelMaintenance: "Vedligeholdelse af luftfugterens vandniveau",
        machineConfigurationNoCanisters: "Maskinkonfigurationen indeholder ingen kanistre.",
        machineName: "Maskinenavn",
        machineSettings: "Maskineindstillinger",
        manualPuncher: "Manuel stansning",
        minDispensedAmount: "Minimal toningsmÃ¦ngde",
        minutes: "Minutter",
        nextRun: "NÃ¦ste runde",
        noAutotasksSet: "Der er ikke angivet nogen autotasks",
        noDataAvailable: "Der er ingen data tilgÃ¦ngelig",
        noMachine: "Ingen maskine er tilsluttet",
        onStart: "PÃ¥ start",
        plugger: "Tilslutningsknap",
        postpone: "DÃ¥se/Spand udsÃ¦tning",
        puncher: "Stansnings knap",
        purgeAll: "Udrens alle",
        purgeOnly: "Udrens kun",
        recirculateAll: "Recirkuler alle",
        recirculateChannels: "Recirkuler kanaler",
        recirculationSpeed: "Recirkulationshastighed",
        recirculationTime: "Recirkulationstid",
        refillAll: "Genopfyld alle",
        refillCanisters: "Genopfyld kanisterne",
        runAt: "Dagligt kl.",
        runDefinedDaysAt: "Definerede dage kl",
        runEvery: "KÃ¸r hver",
        runInDays: "KÃ¸r i dage",
        serialNum: "Serienummer",
        settingsMachine: "Indstillingsmaskine",
        smartPurgeAll: "Smart udrensning af alle",
        smartPurgeChannels: "Smart udrensning af kanaler",
        smartPurgeRules: "Regler for smart udrensning",
        startType: "Starttype",
        stirAll: "RÃ¸r alle",
        stirCanisters: "RÃ¸r kanistrene",
        stirringSpeed: "OmrÃ¸ringshastighed",
        stirringTime: "OmrÃ¸ringstid",
        switchPlateMaintenance: "Skift vedligeholdelse af pladen",
        theCurrentlySelectedMachine: "NuvÃ¦rende valgte maskine",
        threshold: "Begyndelse",
        turntable: "Drejeskive",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "MÃ¦ngde",
        weekdays: "Hverdag"
    },
    mainTab: {
        acceptedFormula: "Accepteret formel",
        addBuildingSite: "Add building site",
        addToFavorites: "TilfÃ¸j til favoritter",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "En eller flere tonepastaer er tilgÃ¦ngelig",
        dispensedPackages: "Tonet pakke",
        dispensingInProgress: "Toning er i gang",
        dispensingIsAborted: "Toning er afbrudt",
        dispensingIsNotAvailable: "Toning er ikke tilgÃ¦ngelig",
        dispensingProgress: "%{done} af %{all}",
        editColorant: "Rediger tonepasta",
        editNote: "Rediger note",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Tving toning",
        formulaInvalidColorants: "Recepten indeholder ugyldige tonepastaer: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Gemte farvekort",
        hiddenProducts: "Gemte produkter",
        historicalFormulas: "Historiske recepter",
        lowerDeltaNumber: "Lavere delta vÃ¦rdi, mere prÃ¦cist match",
        machineError: "Maskinefejl",
        machineIsBusy: "Maskinen er optaget",
        machineNotConnected: "Maskinen er ikke forbundet",
        manualColorantAddition: "Manuel tonepasta tilfÃ¸jelse",
        modifiedFormula: "Recepten er Ã¦ndret",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "Ny farve efter skalering",
        newRgbNotAccuratelyMeasured: "Ny RGB kode er ikke nÃ¸jagtigt, men kun vejledende",
        noBaseAvailable: "Ingen base er tilgÃ¦ngelig",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Ingen tonepastaer",
        noCustomer: "Ingen kunder",
        noCustomers: "Ingen kunder tilgÃ¦ngelige",
        noDispenseNotesAvailable: "Ingen noter for toning er tilgÃ¦ngelig",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Ingen recept er valgt",
        noInternalNotesAvailable: "Ingen interne noter er tilgÃ¦ngelige",
        noNotesAvailable: "Ingen noter er tilgÃ¦ngelige",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Ingen pakker er valgt",
        noProductAvailable: "No product is available",
        noResultsFound: "Der blev ikke fundet nogen resultater",
        openLocalFile: "Ãben fra lokal database",
        openOnlineFile: "Ãben fra internettet",
        order: "Ordre",
        orderingIsNotAvailable: "Ordre er ikke tilgÃ¦ngelig",
        originalColor: "Oprindelig farve",
        overAvailableLevel: "Over det tilgÃ¦ngelige niveau",
        package: "Produkt",
        packageIsRequired: "Pakke er pÃ¥krÃ¦vet",
        packaging: "Emballage",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Udskrivning er ikke tilgÃ¦ngelig",
        productFiles: "Produktfiler",
        productFilesViewer: "Oversigt af produktfiler",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Almindelig pris",
        resetFormulaData: "Ny recept",
        rgbOnlyIndicative: "RGB kun vejledende!",
        saveAsCustom: "Gem som",
        saveToStatsIsNotAvailable: "Det er ikke muligt at gemme til historik",
        searchForCheaper: "SÃ¸g efter billigere",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Speciel pris",
        specialPriceVip: "Speciel pris VIP",
        splitFormula: "Opdel recept",
        withVAT: "med moms",
        withoutVAT: "uden moms"
    },
    marginSettings: {
        allBases: "Alle baser",
        allProducts: "Alle produkter",
        editMargin: "Rediger profit (margin)",
        marginAndDiscountWarning: "Du skal indstille prisberegningsmulighed for brug af margener og rabatter.",
        marginSettings: "Profit (margin) indstillinger",
        marginsFor: "Profit (margin) for",
        markupColorants: "Ãnskede profitprocent (markup) tonepasta",
        sizeOfPackage: "PakkestÃ¸rrelse",
        valueBase: "BasevÃ¦rdi",
        valueColorant: "TonepastavÃ¦rdi"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Ãndre tonepasta enhed",
        payAttention: "VÃ¦r opmÃ¦rksom!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Farvekort filter",
            formulasOverLimit: "Cirka %{count} resultater. PrÃ¸v at skrive flere tegn.",
            foundFormulas: "%{count} recepter fundet",
            help: "HjÃ¦lp:",
            helpText:
                "Skriv f.eks. '%{filter}' for at sÃ¸ge efter recepter, der starter med '%{formula}', produkter der starter med '%{product}' og farvekort '%{fandeck}'.",
            productFilter: "Produktfilter",
            searchInFormulas: "SÃ¸g i recepter",
            typeMore: "Venligst skriv flere tegn."
        },
        menu: {
            actionHistory: "Handlingshistroik",
            additionalFormulaTab: "Ekstra receptfane",
            advancedSettings: "Avancerede indstillinger",
            autotaskSettings: "Autotask",
            availableDatabases: "TilgÃ¦ngelige databaser",
            availablePrices: "TilgÃ¦ngelige priser",
            bugReport: "Fejlrapport",
            canisterBarcodes: "Kanister stregkoder",
            canisterDispensingLogic: "Toningslogik",
            canisterFilling: "Kanisteropfyldning",
            canisterSettings: "Kanisterindstillinger",
            clientServerSettings: "Klient/server forbindelse",
            closing: "Lukker",
            color: "Farve",
            colorModification: "FarveÃ¦ndring",
            colorPanel: "Farvepanelindstillinger",
            colorRepresentation: "FarvereprÃ¦sentation og data",
            colorSearch: "FarvesÃ¸gning",
            colorant: "Tonepasta",
            colorantConsumption: "Tonepasta forbrug",
            colorantPricing: "Tonepasta prissÃ¦tning",
            colorantRefillHistory: "Tonepasta genopfyldningshistorik",
            competitiveSearch: "Simulerende farvesÃ¸gning",
            connections: "Forbindelser",
            currency: "Valutaindstillinger",
            customData: "Specialfremstillet data",
            database: "Database",
            databaseCheck: "Database tjek",
            databaseConnection: "Database forbindelse",
            defaultValues: "StandardvÃ¦rdier",
            devices: "Enheder",
            dispensingHistory: "Toningshistorik",
            dispensingSettings: "Toningsindstillinger",
            driverSettings: "Driver indstillinger",
            environment: "Omgivelser",
            environmentConfiguration: "Omgivelsesindstillinger",
            environmentalSettings: "Omgivelsesindstillinger",
            favorites: "Favoritter",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatering",
            formula: "Formula",
            formulaData: "Data",
            formulaModification: "Formula modification",
            formulaPanels: "Receptspanel",
            formulaSettings: "Receptsindstillinger",
            formulaUnit: "Receptsenhed",
            generalSearch: "Generel sÃ¸gning",
            globalSettingsSearch: "SÃ¸gning efter globale indstillinger",
            helpItems: "HjÃ¦lpindstillinger",
            importAndExport: "Import og eksport",
            importAndExportData: "Importer specialfremstillet data",
            importCustomData: "Importer specialfremstillet data",
            initialFormulaTab: "Oprindelige receptfane",
            interfaceSettings: "Interface indstillinger",
            keyboardShortcuts: "Tastatur genveje",
            language: "Sprog",
            languageSettings: "Sprog indstillinger",
            layout: "OpsÃ¦tning",
            license: "Licens",
            licenseData: "Licensdata",
            licenseIdentification: "Licensidentifikation",
            licenseStatus: "Licensstatus",
            licenseSupplier: "LicensleverandÃ¸r",
            licenseVersion: "Licensversion",
            localData: "Lokale data",
            machine: "Maskineinformation",
            machineActions: "Maskinehandlinger",
            machineAndDevices: "Maskine og apparater",
            machineManagement: "Maskinstyring",
            machineSettings: "Maskineindstillinger",
            mainSettings: "Hovedindstillinger",
            maintenance: "Vedligeholdelse",
            marginAndDiscount: "Margin og rabat",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Navigationselementer",
            newFormulaWindow: "Recept",
            orderSearch: "OrdresÃ¸gning",
            orderSettings: "Bestillingsindstillinger",
            packageSurcharge: "PakketillÃ¦g",
            popUps: "Pop-op",
            posInfo: "Salgsstedsinformation",
            price: "Prisindstillinger",
            priceManagement: "Pris administration",
            priceSettings: "Prisindstillinger",
            pricingOptions: "Prisindstillinger",
            printSettings: "Udskrivningsindstillinger",
            productPricing: "Produkt prissÃ¦tning",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Hurtig toneindstilling",
            rccConfig: "RCC (Redlike Control Center) indstillinger",
            rccConnection: "RCC (Redlike Control Center) forbindelse",
            rccSettings: "RCC (Redlike Control Center) indstillinger",
            refillSettings: "Refill Settings",
            refillingLogic: "Genopfyldningslogik",
            registration: "Registrering",
            searchSettings: "SÃ¸geindstillinger",
            serverPlugins: "Server plug-in",
            serviceActions: "Serverhandlinger",
            settings: "Indstillinger",
            simplifiers: "Simplificeringer",
            singleActions: "Enkelte handlinger",
            smartPurgeRules: "Regler for smart udrensning",
            softwareOptions: "Software muligheder",
            spectroSettings: "Spektrometerindstillinger",
            statistics: "Statistik",
            switchToFrontdesk: "Skift til reception",
            switchToFullRedlike: "Skift til %{name}",
            switchToLight: "Skift til %{name}",
            switchToMachine: "Skift til maskine",
            tabs: "Fane og pop-op",
            testBarcodes: "Testning af stregkode",
            updateOptions: "Opdateringsmuligheder",
            userManagemenet: "Brugeradministration",
            visibleUnits: "Synlige enheder"
        },
        navBar: {
            barcode: "Stregkode",
            help: "HjÃ¦lp",
            hideItems: "Skjul produkter / farvekort"
        },
        notificationPanel: {
            noNotifications: "Ingen nye notifikationer"
        },
        tabBar: {
            closeActive: "Luk aktiv",
            closeAll: "Luk alle",
            closeAllExceptActive: "Luk alle undtagen aktive",
            customFormula: "Custom Formula",
            dispensingHistory: "Toningshistorik",
            favorites: "Favoritter",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Tildel",
        assignment: "Arbejdsopgave",
        createdDate: "Oprettelsesdato",
        finishDispensing: "Afslut toning",
        foundInOrders: "Fundet i ordrer",
        inactiveDatabase: "Recepten er fra en inaktiv eller ukendt database %{0}",
        inactiveUnknownDatabase: "Recepten er fra en inaktiv eller ukendt database",
        newOrderReceived: "Du har modtaget en ny ordre!",
        noOrderSelected: "Ingen ordre valgt",
        release: "Udgiv",
        status: {
            accepted: "accepteret",
            canceled: "annulleret",
            created: "kreeret",
            done: "fÃ¦rdig",
            partlyDone: "delvist fÃ¦rdig",
            preparing: "forbereder",
            unknown: "ukendt"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresse",
        contactName: "Kontakt navn",
        contactPerson: "Kontaktperson",
        identification: "Identifikation",
        machineInformation: "Maskine information",
        pos: "Salgssted",
        secondAddress: "Anden adresse",
        shopIdentification: "Butiksidentifikation",
        shopName: "Butiksnavn",
        url: "Enhedsressourcefinder",
        zipCode: "Postnummer"
    },
    priceTypeList: {
        priceBasePurchase: "Fremstillingspris for base",
        priceBaseSell: "Salgspris for base",
        priceBaseSellFull: "Salgspris for base",
        priceCntPurchase: "Fremstillingspris for tonepasta",
        priceCntPurchaseByColorantName: "Fremstillingspris for %{0} tonepasta",
        priceCntPurchaseByName: "Fremstillingspris for tonepasta ved navn",
        priceCntSell: "Salgspris for tonepasta",
        priceCntSellByColorantName: "Salgspris for %{0} tonepasta",
        priceCntSellByName: "Salgspris for tonepasta ved navn",
        priceCntSellFull: "Salgspris for tonepastaer",
        priceCntSellFullByColorantName: "Salgspris for tonepasta %{0}",
        priceCntSellFullByName: "Salgspris for tonepastaer pr. navn",
        priceGroupBarcode: "Prisgruppens stregkode",
        priceMarginAll: "Profit (margin) for alle pakker",
        priceMarginPerPkg: "Profit (margin) for Ã©n pakke",
        priceSellPriceAll: "Salgspris for alle pakker",
        priceSellPricePerKg: "Salgspris pr. kilo",
        priceSellPricePerL: "Salgspris pr. Liter",
        priceSellPricePerPkg: "Salgspris for Ã©n pakke",
        priceSurchargeAll: "Ekstragebyr for alle pakker",
        priceSurchargePerPkg: "Ekstragebyr for Ã©n pakke",
        priceTintPurchaseAll: "Tonings fremstillingspris for alle pakker",
        priceTintPurchasePerPkg: "Tonings fremstillingspris for Ã©n pakker",
        priceTintSellFullAll: "Salgspris for toning af alle pakker",
        priceTintSellFullAllPerPackage: "Salgspris for toning af pr. pakke",
        priceTotalPurchaseAll: "Totale fremstillingspris for alle pakke",
        priceTotalPurchasePerKg: "Totale fremstillingspris pr. kilo",
        priceTotalPurchasePerL: "Totale fremstillingspris pr. Liter",
        priceTotalPurchasePerPkg: "Totale fremstillingspris for Ã©n pakke",
        priceTotalSellFullAll: "Samlede salgspris for alle pakker",
        priceTotalSellFullPerKg: "Samlet salgspris pr. kg",
        priceTotalSellFullPerLiter: "Samlet salgspris pr. liter",
        priceTotalSellFullPerPackage: "Samlet salgspris pr. pakke"
    },
    pricing: {
        allBases: "Alle baser",
        allPackages: "Alle pakker",
        backup: "Backup",
        basesOfProduct: "Baser af %{productName}",
        colorantPricing: "Tonepasta prissÃ¦tning",
        export: "Eksport",
        import: "Importer",
        packagePricing: "Pakke prissÃ¦tning",
        packageSurcharge: "Ekstragebyr pÃ¥ pakke",
        packages: "Pakker",
        packagesOfProduct: "Pakker af %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Prisgruppe for priser pr. Liter",
        priceGroups: "Prisgrupper",
        pricePerLiter: "Pris pr. Liter",
        productPricing: "Produkt prissÃ¦tning",
        purchasePrice: "IndkÃ¸bspris",
        purchasePricePerLiter: "IndkÃ¸bspris pr. Liter",
        sellPrice: "Salgspris",
        surcharge: "Ekstragebyr"
    },
    print: {
        adminRightsRequired: "Admin. rettigheder er nÃ¸dvendige for at redigere eller oprette en ny skabelon.",
        allowAutomaticPrint: "Automatisk udskrivning",
        allowPrintAfterDispensing: "Tillad udskrivning efter toning",
        allowPrintBeforeDispensing: "Tillad udskrivning fÃ¸r toning",
        automaticPrint: "Udskriv automatisk",
        choosePrinter: "Printer",
        chooseSettings: "Rediger indstillinger",
        chooseTemplate: "Skabelon",
        copies: "Kopier",
        createTemplate: "Opret skabelon",
        createTemplateHint: "Opret en ny skabelon fra bunden. Gem det i skabelonmappen, og genstart RCC.",
        defaultPrinter: "Standardprinter",
        defaultSettings: "Standardindstillinger",
        defaultTemplate: "Standardskabelon",
        editTemplate: "Rediger skabelon",
        editTemplateHint: "Rediger %{name}. Ãndringer vil vÃ¦re synlige efter genstart af RCC.",
        noEditTemplate: "Ingen skabelon at redigere",
        noPrinterSelected: "Ingen printer er valgt",
        noPrintersAvailable: "Der er ingen printer til rÃ¥dighed",
        noTemplateSelected: "Ingen skabelon er valgt",
        noTemplatesAvailable: "Der er ingen skabelon til rÃ¥dighed",
        numberOfCopies: "Antal kopier",
        openTemplateEditor: "Ãben skabeloneditor",
        printAfterDispensing: "Udskriv efter toning",
        printAsImage: "Udskriv som billede",
        printBeforeDispensing: "Udskriv fÃ¸r toning",
        printOnRequest: "Udskriv pÃ¥ anmodning",
        printOptions: "Udskrivningsmuligheder",
        printPagesAfterDispensing: "Antal edikettekopier",
        printPagesBeforeDispensing: "Antal edikettekopier",
        printPreview: "Udskriv forhÃ¥ndsvisning",
        printSettings: "Udskrivningsindstillinger",
        printTaskLinkVariable: "Link til variabel",
        printVariable: "Udskriftsvariabel",
        printerName: "Printernavn",
        printerOptions: "Printermuligheder",
        printerSettings: "Printerindstillinger",
        quickTintTemplate: "Hurtig toning skabelon",
        setDefaultPrinter: "Indstil standardprinter",
        setDefaultTemplate: "Indstil standardskabelon",
        setQuickTintTemplate: "Indstil hurtig toning skabelon",
        showPreviewDialogBeforePrint: "Vis forhÃ¥ndsvisning dialog fÃ¸r udskrivning",
        template: "Skabelon",
        templateName: "Skabelonnavn",
        templateSettings: "Skabelonindstillinger "
    },
    printTemplate: {
        baseCode: "Basekode",
        baseName: "Base navn",
        bfs: "BFS/Bredde-fÃ¸rst-sÃ¸gning",
        colorantType: "Colorant type",
        customerCity: "Kunde by",
        customerEmail: "Kunde email",
        customerName: "Kunde navn",
        customerPhone: "Kunde telefonnummer",
        customerStreet: "Kunde gade",
        customerZipCode: "Kunde postnummer",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS grad",
        orderQrCode: "QR kode",
        packageOrderCount: "Antal pakkeordrer",
        posAddress: "Salgssted adresse",
        posAddressSecond: "Salgssted adresse 2",
        posCity: "Salgssted by",
        posContact: "Kontaktperson ved salgsstedet",
        posEmail: "Salgssted email",
        posPhone: "Salgssted telefonnummer",
        posUrl: "Salgssted Enhedsressourcefinder (Url)",
        posZipCode: "Salgssted postnummer",
        priceBasePurchaseWithTax: "Fremstillingspris for base inklusiv moms",
        priceBaseSellWithTax: "Salgspris for base inklusiv moms",
        priceCntPurchaseWithTax: "Fremstillingspris for tonepasta inklusiv moms",
        priceCntTotalSellWithTax: "Salgspris for tonepasta inklusiv moms",
        priceMarginAllWithTax: "Profit (margin) for alle pakker inklusiv moms",
        priceMarginPerPkgWithTax: "Profit (margin) for Ã©n pakker inklusiv moms",
        priceSellPriceAllWithTax: "Salgspris for alle pakker inklusiv moms",
        priceSellPricePerKgWithTax: "Salgspris pr. Kilo inklusiv moms",
        priceSellPricePerLWithTax: "Salgspris pr. Liter inklusiv moms",
        priceSellPricePerPkgWithTax: "Salgspris for Ã©n pakke inklusiv moms",
        priceSurchargeAllWithTax: "Ekstragebyr for alle pakker inklusiv moms",
        priceSurchargePerPkgWithTax: "Ekstragebyr for Ã©n pakke inklusiv moms",
        priceTintPurchaseAllWithTax: "Fremstillingspris for toning af alle pakker inklusiv moms",
        priceTintPurchasePerPkgWithTax: "Fremstillingspris for toning af Ã©n pakke inklusiv moms",
        priceTotalPurchaseAllWithTax: "Totale fremstillingspris for alle pakker inklusiv moms",
        priceTotalPurchasePerKgWithTax: "Totale fremstillingspris pr. Kilo inklusiv moms",
        priceTotalPurchasePerLWithTax: "Totale fremstillingspris pr. Liter inklusiv moms",
        priceTotalPurchasePerPkgWithTax: "Totale fremstillingspris for Ã©n pakke inklusiv moms",
        productAltName: "Produkt",
        recipeInline: "Recept"
    },
    products: {
        bases: "Base",
        numberOfProducts: "Antal produkter",
        packagesFor: "Pakker til",
        sizeOfPackage: "PakkestÃ¸rrelse"
    },
    purgeModal: {
        purgeAll: "Udrens alle",
        purgeAllChannels: "Udrens alle kanaler",
        purgeVolume: "Udrens volumen",
        startPurge: "Start udrensning"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Toning under udfÃ¸rsel",
        dispensingIsNotAvailable: "Toning er ikke tilgÃ¦ngelig",
        machineNotConnected: "Ingen maskine er forbundet",
        noColorantsSelected: "Ingen tonepastaer er valgt",
        noPrinterAvailable: "Udskrivningen kan ikke udfÃ¸res, da der ikke er nogen printer til rÃ¥dighed.",
        noTemplateAvailable: "Udskrivningen kan ikke udfÃ¸res, da der ikke er nogen skabelon til rÃ¥dighed.",
        overMaxCanisterSize: "Ãn eller flere tonepastaers er ugyldige"
    },
    quickTintSettings: {
        alphabetically: "Alfabetisk",
        byCanister: "Af kanister",
        closeAfterDispensing: "Luk efter toning",
        closeBeforeDispensing: "Luk fÃ¸r toning",
        quickTintSettings: "Hurtig-toningsindstillinger",
        sorting: "Sortere",
        windowClosingRules: "Regler for vindueslukning"
    },
    rccButtons: {
        abort: "afbryd",
        all: "alle",
        cancel: "annuller",
        continue: "fortsÃ¦t",
        help: "hjÃ¦lp",
        ignore: "ignorer",
        no: "ingen",
        noToAll: "ikke til alle",
        ok: "okay",
        postpone: "udsÃ¦t",
        resume: "genoptag",
        retry: "forsÃ¸g igen",
        skip: "spring over",
        yes: "ja",
        yesToAll: "ja til alle"
    },
    rccDialog: {
        98: "Venligst kontroller base %{0} med stregkoden",
        99: "Venligst indsÃ¦t base %{0} og bekrÃ¦ft (tryk Okay)",
        100: "Dispenser er i fejltilstand, nulstil fejl?",
        101: "Dispenser er i fejltilstand, og kan derfor ikke fortsÃ¦tte",
        102: "Nulstilling fejlede, og kan derfor ikke fortsÃ¦tte",
        103: "Recepten indeholder ugyldig tonepasta: %{0}",
        104: "Recepten indeholder ugyldige tonepastaer: %{0}",
        105: "Tonepasta: %{0} er under advarselsniveau",
        106: "Tonepastaerne: %{0} er under advarselsniveau",
        107: "Tonepasta: %{0} er under kritisk niveau",
        108: "Tonepastaerne: %{0} er under kritisk niveau",
        109: "Placer dÃ¥se/spand",
        110: "Placer base: %{0} for recept: %{1}",
        111: "Fjern dÃ¥se/spand",
        112: "Stans dÃ¥sen/spanden?",
        113: "Nulstiller fejl, vent venligst",
        114: "Flytter hylde, vent venligst",
        115: "Stanser dÃ¥sen/spanden, vent venligst",
        116: "Toner recepten %{0}, vent venligst | Pakke: %{1} af %{2} | Produkt: %{3} | Base: %{4} | DÃ¥se/Spand stÃ¸rrelse: %{5}",
        117: "Toner recepten %{0}, vent venligst | Pakke: %{1} af %{2} | Produkt: %{3} | Base: %{4} | DÃ¥se/Spand stÃ¸rrelse: %{5}",
        118: "Toner, vent venligst|Pakke: %{0} of %{1}",
        119: "Toner, vent venligst|Pakke: %{0} of %{1}",
        120: "Annullerer toning, vent venligst",
        121: "Valider stregkoden pÃ¥ dÃ¥sen/spanden",
        122: "Valider basens stregkode | Produkt: %{0} | Base: %{1} | DÃ¥se/Spand stÃ¸rrelse: %{2}",
        123: "Toningsprocessen er blevet afbrudt. Ãnsker du at genoptage toningen?",
        124: "Der forekom en toningsfejl %{0} : %{1}. Ãnsker du at genoptage toningen?",
        125: "SÃ¸rg for, at den tidligere anvendte dÃ¥se er placeret",
        126: "SÃ¸rg for at bruge en ny dÃ¥se/spand da toningsprocessen vil starte forfra",
        127: "Tonepasta: %{0} er under den minimale doseringsmÃ¦ngde. Vil du fortsÃ¦tte pÃ¥ trods af denne advarsel?",
        128: "Tonepastaer: %{0} er under den minimale doseringsmÃ¦ngde. Vil du fortsÃ¦tte pÃ¥ trods af denne advarsel?",
        129: "Den valgte formel bryder overfyldningsreglen, den samlede mÃ¦ngder tonepastaer: %{0} %{1}, maksimalt tilladte mÃ¦ngder tonepastaer: %{2} %{3}. Vil du fortsÃ¦tte pÃ¥ trods af denne advarsel?",
        130: "Tonemaskinen er i fejltilstand, skal fejlen nulstilles?",
        131: "Tonemaskinen er i fejltilstand og kan derfor ikke fortsÃ¦tte",
        132: "Nulstilling fejlede og kan derfor ikke fortsÃ¦tte",
        133: "Udrensningsrecepten er tom og kan derfor ikke fortsÃ¦tte",
        134: "Udrenslingsrecepten indeholder dele der ikke kan udrenses, Ã¸nsker du at fortsÃ¦tte?",
        135: "Placer spand til udrensningen",
        136: "Fjern spand fra udrensning",
        137: "Nulstiller fejl, vent venligst",
        138: "Flytter hylde, vent venligst",
        139: "Udrenser, vent venligst",
        140: "Udrenser, vent venligst",
        141: "Annullerer udrensning, vent venligst",
        142: "Spand til udrensning mangler, sÃ¸rg for at spanden er placeret korrekt",
        143: "Udrenslingsrecepten indeholder dele der ikke kan udrenses, Ã¸nsker du at fortsÃ¦tte?",
        144: "Placer spand til udrensningen",
        145: "Forbereder, vent venligst",
        146: "FÃ¦rdiggÃ¸re, vent venligst",
        150: "RengÃ¸rer, vent venligst",
        151: "RengÃ¸rer, vent venligst",
        152: "Annullerer rengÃ¸rring, vent venligst",
        160: "Recirkulerer, vent venligst",
        161: "Recirkulerer, vent venligst",
        162: "Annullerer recirkulation, vent venligst",
        170: "OmrÃ¸rer, vent venligst",
        171: "OmrÃ¸rer, vent venligst",
        172: "Annullerer omrÃ¸ring, vent venligst",
        180: "Initialiserer forbindelsen til tonemaskinen, vent venligst",
        181: "Forbindelse til tonemaskinen kan ikke etableres %{0}: %{1}",
        182: "Forbindelse til tonemaskinen kan ikke etableres. Se logfiler for mere information",
        183: "Tonemaskine mangler tonepasta: %{0}, der er defineret i din database",
        184: "Tonemaskine mangler tonepastaer: %{0}, der er defineret i din database",
        185: "Lukker forbindelsen til tonemaskinen, vent venligst",
        190: "Luk servicevinduet for at fortsÃ¦tte",
        200: "Nulstiller, vent venligst",
        201: "HÃ¥rd nulstilling, vent venligst",
        202: "Initialisering, vent venligst",
        203: "Nulstilling af fejl, vent venligst",
        205: "Autocap Ã¥bner, vent venligst",
        206: "Autocap lukker, vent venligst",
        207: "Flytter Autocap, vent vwnligst",
        210: "Stansning, vent venligst",
        211: "Tilslutning, vent venligst",
        215: "Flytter hylde opad, vent venligst",
        216: "Flytter hylde nedad, vent venligst",
        217: "Flytter hylde, vent venligst",
        220: "Flytter bord til genopfyldningsposition: %{0}, vent venligst",
        221: "Flytter bord hjem, vent venligst",
        222: "Flytter bord, vent venligst",
        230: "Toningsmaskinen optaget, vent venligst",
        240: "Venligst genopfyld kanister %{0}",
        241: "Venligst genopfyld kanister %{0}",
        242: "Placere kanister: %{0} (%{1}) til genopfyldningsposition",
        243: "Venligst genopfyld kanister %{0} ved brug af stegkode",
        244: "Venligst genopfyld kanister %{0} ved brug af stegkode",
        250: "Fjern bÃ¸rstebeholderen, rengÃ¸r den og fyld den med vand i henhold til instruktionerne",
        251: "Stil bÃ¸rstebeholderen tilbage",
        254: "Ãbner autocap",
        255: "RengÃ¸r autocap ifÃ¸lge instruktionerne",
        256: "BekrÃ¦ft, nÃ¥r rengÃ¸ringen er afsluttet, og autocap er pÃ¥ plads igen",
        257: "Lukker autocap",
        260: "Fjern kontaktpladen og rengÃ¸r den",
        261: "SÃ¦t kontaktpladen tilbage",
        265: "RengÃ¸r maskinen med en klud, og fjern al den spildt tonepasta eller anden vÃ¦ske",
        266: "BekrÃ¦ft nÃ¥r det er udfÃ¸rt",
        270: "Genopfyld luftfugterens vandbeholder og bekrÃ¦ft nÃ¥r det er udfÃ¸rt",
        271: "Genopfyld luftfugterens vandbeholder og bekrÃ¦ft nÃ¥r det er udfÃ¸rt",
        272: "Vandniveauet er stadig lavt, tjek det igen",
        273: "Vandniveauet er stadig lavt, tjek det igen",
        274: "Tjek vandniveauet i luftfugterens vandbeholder og genopfyld hvis det er nÃ¸dvendigt",
        275: "Vent venligst",
        280: "Genstarter computer",
        281: "Slukker computer",
        300: "Base mangler, tjek om dÃ¥se/spanden er placeret korrekt",
        301: "Forbereder, vent venligst",
        302: "FÃ¦rdiggÃ¸re, vent venligst",
        303: "Recepten kan ikke tones, da den indeholder tonepasta: %{0}, hvilket er over den maksimale doseringsmÃ¦ngde, der er defineret for kanisteren",
        304: "Recepten kan ikke tones, da den indeholder tonepastaer: %{0}, hvilke er over de maksimale doseringsmÃ¦ngde, der er defineret for kanisterene",
        305: "Tonepasta: %{0} kan ikke doseres pÃ¥ Ã©n gang. Vil du dele recepten op?",
        306: "Tonepastaerne: %{0} kan ikke doseres pÃ¥ Ã©n gang. Vil du dele recepten op?",
        307: "Tonepasta: %{0} bliver ikke doseres af tonemaskinen, vil du fortsÃ¦tte og tilfÃ¸je det manuelt?",
        308: "Tonepastaerne: %{0} bliver ikke doseres af tonemaskinen, vil du fortsÃ¦tte og tilfÃ¸je dem manuelt?",
        309: "Den valgte recept er tom, brug basen som den er",
        310: "Der kan ikke doseres nogen tonepastaer, forbered base til manuel tilsÃ¦tning af tonepastaer",
        311: "Fjern base og forbered den til manuel dosering af tonepasta",
        312: "Doser manuelt %{0} %{1} af tonepasta: %{2}, bekrÃ¦ft nÃ¥r det er udfÃ¸rt",
        313: "Doser recepten manuelt",
        314: "Den valgte recept bryder overfyldningsreglen, den samlede mÃ¦ngde tonepasta: %{0} %{1}, maksimalt tilladte mÃ¦ngder tonepasta: %{2} %{3}. Vil du fortsÃ¦tte pÃ¥ trods af denne advarsel?",
        315: "Scan eller indtast UFI kode for base spand",
        316: "Scan eller indtast UFI kode for base spand|Produkt: %{0}|Base: %{1}|SpandstÃ¸rrelse: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatisk udrensning vil blive startet",
        401: "Automatisk udrensning vil blive startet",
        405: "BÃ¸rstebeholder skal vedligeholdes",
        406: "BÃ¸rstebeholder skal vedligeholdes",
        410: "Automatisk vedligeholdelse af lÃ¥g startes",
        411: "Automatisk vedligeholdelse af lÃ¥g startes",
        415: "Kontaktpladen skal rengÃ¸res",
        416: "Kontaktpladen skal rengÃ¸res",
        420: "Tonemaskine skal rengÃ¸res",
        421: "Tonemaskine skal rengÃ¸res",
        425: "Genopfyldning af kanister vil blive igangsat",
        426: "Genopfyldning af kanister vil blive igangsat",
        430: "Computergenstart er planlagt",
        431: "Computergenstart er planlagt",
        435: "Computernedlukning er planlagt",
        436: "Computernedlukning er planlagt",
        440: "Rensning af tonemaskine er planlagt",
        441: "Rensning af tonemaskine er planlagt",
        445: "Dispenserrecirkulation er planlagt",
        446: "Dispenserrecirkulation er planlagt",
        450: "Dispenser omrÃ¸ring er planlagt",
        451: "Dispenser omrÃ¸ring er planlagt",
        990: "Tonemaskine-fejl opstod %{0}: %{1}. Vil du prÃ¸ve opgaven igen?",
        991: "Intern fejl opstod: %{0}",
        200000001: "Placer dÃ¥se/spand",
        200000002: "Fjern dÃ¥se/spand",
        200000003: "MÃ¦ngde for '%{0}' under minimum toningsmÃ¦ngde, fortsÃ¦t pÃ¥ egen risiko?",
        200000004: "Genopfyld '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Databasesti",
        dispenser: "Tonemaskine",
        dispenserConfigurationFile: "Tonemaskine-konfigurationsfil",
        driverPath: "Driver sti",
        extensionPath: "ForlÃ¦ngelsesti",
        folder: "Mappe",
        formulaPath: "Receptsti",
        host: "VÃ¦rtsmaskine",
        iddPath: "IDD konfigurationsfil",
        italtintoPath: "Italtinto konfigurationssti",
        lldPath: "HLD rodbibliotek",
        machineType: "Maskine type",
        noMachineAvailable: "Ingen maskine er tilgÃ¦ngelig",
        protocolVersion: "Protokolversion",
        rccDriverSettings: "Driverindstillinger",
        resultPath: "Resultatssti",
        save: "Gem indstillinger",
        saveSettingsWarning: "Advarsel! Ãndringer i dette afsnit kan forÃ¥rsage funktionsfejl i tonemaskinen.",
        serviceSwPath: "Servicesoftware sti",
        simulationPath: "Simuleringssti"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Tillad manuel tonepasta dosering",
        ask: "SpÃ¸rg",
        canHandlingOptions: "DÃ¥se/spand hÃ¥ndteringsindstillinger",
        checkCanBeforeDispense: "Tjek dÃ¥se/spand fÃ¸r toning",
        checkOverfill: "Tjek overfyldning",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Kun validering af tonepastapakke",
        disable: "Deaktivere",
        dispenseInvalidColorants: "Doser ugyldige tonepastaer",
        dispensingOptions: "Toningsindstillinger",
        enable: "Aktiver",
        enableUserIdentification: "Brugeridentifikation",
        fullValidation: "Fuld validering",
        machineAccuracyWarning: "Advarsel om maskinens nÃ¸jagtighed",
        machineOptions: "Maskinindstillinger",
        machineUnit: "Maskine enhed",
        minimalDispenseAmount: "Minimale doseringsmÃ¦ngde",
        placeCanSensor: "Sensor for placering af dÃ¥se/spand",
        placeCanSensorDelay: "Forsinkelse pÃ¥ sensor for placering af dÃ¥se/spand",
        rccMachineSettings: "Maskinindstillinger",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Sensor for flytning af dÃ¥se/spand",
        removeCanSensorDelay: "Forsinkelse pÃ¥ sensor for flytning af dÃ¥se/spand",
        save: "Gem indstillinger",
        sec: "sekunder",
        skipPlaceCanDialog: "Spring over dialog om placering af dÃ¥se/spand",
        skipRemoveCanDialog: "Spring over dialog om flytning af dÃ¥se/spand",
        splitFormula: "Del recepten",
        tmcEnabled: "Aktiver TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Valider stregkode pÃ¥ base dÃ¥sen/spanden",
        validateBarcodeRefill: "Valider stregkode pÃ¥ kanisteren fÃ¸r genopfyldning",
        validateColorantsDuringInit: "Valider tonepasta under initialisering"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Der kÃ¸rer nogle handlinger pÃ¥ maskinen",
        addLevel: "TILFÃJ NIVEAU",
        addManually: "TilfÃ¸j manuelt",
        barcodeNotSet: "Kanister %{colorantName} (%{canisterName}) har ikke fÃ¥et tildelt en stregkode.",
        cancel: "ANNULLER",
        dispenseFormula: "Recept",
        dispenserIdle: "Maskinen er inaktiv",
        dispenserIsBusy: "Maskine i brug",
        dispenserIsIdle: "Maskine er inaktiv",
        dispenserIsReady: "Maskinen er klar til yderligere opgaver",
        dispensingFormula: "Recept",
        errorCode: "Fejlkode",
        explanation: "Forklaring",
        fillToMax: "Fyld maksimalt",
        finished: "FÃ¦rdig",
        inProgress: "I gang",
        machineIsReady: "Maskinen er klar",
        moveToFill: "Flyt til udfyldning",
        noMachineDialog: "Ingen maskine er forbundet",
        of: "fra",
        packageSize: "Pakke stÃ¸rrelse",
        placeBaseCan: "Placer base-dÃ¥se/spand",
        pleaseCheckYourMachineConnection: "Venligst tjek maskinens forbindelse",
        pleaseRefill: "Venligst genopfyld",
        solution: "LÃ¸sning",
        subErrors: "Fejl",
        timeToEnd: "Tid til slut",
        tintingFormula: "Recept",
        tintingPleaseWait: "Toner, vent venligst",
        validateBaseCan: "Validere base dÃ¥se/spand",
        waiting: "Venter"
    },
    rccSettigns: {
        rccSettigns: "RCC (Redlike Control Center) forbindelse",
        rccUrl: "RCC (Redlike Control Center) URL"
    },
    rccSpectroDialog: {
        100: "Opretter forbindelse til din enhed via Bluetooth. SÃ¸rg for, at du har Bluetooth aktiveret, og at dit instrument er tÃ¦ndt.",
        101: "Instrumentet er ikke blevet fundet. Vil du prÃ¸ve igen?",
        110: "SÃ¸rg for, at Nano er tilsluttet, og tryk pÃ¥ instrumentknappen for at starte initialiseringen",
        111: "Nano er ikke blevet fundet. Vil du prÃ¸ve igen?",
        112: "Frakobl Nano, vent 10 sekunder, tilslut det igen og fortsÃ¦t",
        120: "Forbinder din enhed, vent venligst",
        121: "Instrumentet er ikke blevet fundet. Vil du prÃ¸ve igen?",
        200: "Placer instrumentet pÃ¥ den sorte flise, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        201: "Placer instrumentet pÃ¥ den sorte flise og fortsÃ¦t",
        202: "Placer instrumentet pÃ¥ den sorte flise og tryk pÃ¥ instrumentknappen",
        205: "Placer instrumentet pÃ¥ den hvide flise, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        206: "Placer instrumentet pÃ¥ den hvide flise og fortsÃ¦t",
        207: "Placer instrumentet pÃ¥ den hvide flise og tryk pÃ¥ instrumentknappen",
        210: "Placer instrumentet pÃ¥ diagnostisk flise, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        211: "Placer instrumentet pÃ¥ diagnostisk flise og fortsÃ¦t",
        212: "Placer instrumentet pÃ¥ diagnostisk flise og tryk pÃ¥ instrumentknappen",
        215: "Luk instrumentdÃ¦kslet, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        216: "Luk instrumentdÃ¦kslet og fortsÃ¦t",
        217: "Luk instrumentdÃ¦kslet og tryk pÃ¥ instrumentknappen",
        220: "Placer instrumentet pÃ¥ nulpladen, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        221: "Placer instrumentet pÃ¥ nulpladen og fortsÃ¦t",
        222: "Placer instrumentet pÃ¥ nulpladen og tryk pÃ¥ instrumentknappen",
        224: "Placer instrumentet pÃ¥ kalibreringspladen, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        225: "Placer instrumentet pÃ¥ kalibreringspladen, og fortsÃ¦t",
        226: "Placer instrumentet pÃ¥ kalibreringspladen, og tryk pÃ¥ instrumentknappen",
        227: "Placer instrumentet pÃ¥ kalibreringspladen, og tryk pÃ¥ instrumentknappen",
        295: "Afslut kalibreringen i drivervinduet",
        296: "Instrumentet er ikke tilsluttet, vil du Ã¥bne forbindelsen til det?",
        297: "Forberedelse til kalibreringstrin, vent venligst",
        298: "Kalibrerer, vent venligst",
        299: "Afslut kalibreringstrin, vent venligst",
        300: "Placer instrumentet pÃ¥ prÃ¸ven, og fortsÃ¦t eller tryk pÃ¥ instrumentknappen",
        301: "Placer instrumentet pÃ¥ prÃ¸ven og fortsÃ¦t",
        302: "Placer instrumentet pÃ¥ prÃ¸ven og tryk pÃ¥ instrumentknappen",
        303: "Instrumentet er ikke kalibreret. Vil du fortsÃ¦tte med kalibreringen?",
        304: "Instrumentet er ikke tilsluttet, vil du Ã¥bne forbindelsen til det?",
        390: "VÃ¦lg mÃ¥lemetode",
        395: "Afslut mÃ¥lingen i drivervinduet",
        397: "Forbereder mÃ¥ling, vent venligst",
        398: "MÃ¥ler, vent venligst",
        399: "FÃ¦rdiggÃ¸re mÃ¥ling, vent venligst",
        498: "Downloader mÃ¥linger, vent venligst",
        499: "Downloader alle mÃ¥linger, vent venligst",
        900: "Instrumentfejl opstod %{0}: %{1}. Vil du prÃ¸ve opgaven igen?",
        901: "Instrumentfejl opstod: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Computeren skal have Bluetooth-forbindelse. Spektrometeret skal parres med computeren. Windows 10 med 2018 automn-opdatering krÃ¦vet.",
        DatacolorSilent:
            "NÃ¥r du bruger lydlÃ¸s tilstand vises Datacolor-vinduer direkte i %{name}. I disse vinduer kan spektroparametre ikke Ã¦ndres.",
        DatacolorUseDiagnosticTile: "Brug af diagnostisk flise forbedrer mÃ¥lekvaliteten.",
        comPort: "Com-port",
        diagnosticTile: "Datafarve bruger diagnostiske fliser",
        measureModes: "MÃ¥lemetoder",
        measureModesOrder: "RÃ¦kkefÃ¸lge af mÃ¥lemetoder",
        model: "Model",
        noSpectroAvailable: "Intet spektrometer er tilgÃ¦ngeligt",
        rccSpectroSettings: "Spektrometer indstillinger",
        save: "Gem indstillinger",
        silent: "Datafarve tavs",
        simulationPath: "Simulationssti",
        spectroType: "Spektrometertype",
        useProfiledValues: "Brug profilerede vÃ¦rdier"
    },
    recirculateChannels: {
        recirculateAllChannels: "Gencirkuler alle kanaler",
        recirculateChannels: "Gencirkuler kanaler",
        recirculatingSpeed: "Gencirkulerings hastighed",
        recirculatingTime: "Gencirkulerings tid",
        startRecirculating: "Start gencirkulering"
    },
    redlikeLight: {
        finishPreviousSteps: "Venligst fÃ¦rdiggÃ¸r tidligere trin",
        searchBySpectro: "SÃ¸g med spektrometer",
        searchFormula: "SÃ¸g efter recept",
        selectBase: "VÃ¦lg base",
        selectColor: "VÃ¦lg farve",
        selectCustomer: "VÃ¦lg kunde",
        selectFandeck: "VÃ¦lg farvekort",
        selectPackage: "VÃ¦lg pakke",
        selectProduct: "VÃ¦lg produkt",
        startSelectFandeck: "Start med at vÃ¦lge et farvekort",
        startSelectProduct: "Start med at vÃ¦lge et produkt",
        stepByStepProgress: "Du kan gÃ¥ videre trin for trin",
        typeHereToSearch: "Indtast her for at sÃ¸ge",
        typeToFilter: "Filtertype"
    },
    restartModal: {
        computerNeedsRestart: "Computeren har brug for at blive genstartet",
        notCompletelyTranslated:
            "SprogÃ¦ndring krÃ¦ver genstart af software. Nogle dele af softwaren er muligvis ikke oversat fuldstÃ¦ndigt pÃ¥ dette tidspunkt.",
        restartIsRequired: "Software genstart er pÃ¥krÃ¦vet, efter at Ã¦ndringerne er foretaget.",
        softwareNeedsRestart: "%{name} Har brug for genstart!"
    },
    searchPanel: {
        basePlaceholder: "eller indtast base",
        baseStartPlaceholder: "Indtast base",
        colorCodeNamePlaceholder: "eller skriv receptkode/-navn",
        colorCodeNameStartPlaceholder: "Starte med at skrive et receptkode/-navn",
        colorCodePlaceholder: "eller indtast en receptkode",
        colorCodeStartPlaceholder: "Start med at indtaste en receptkode",
        colorNameCodePlaceholder: "eller skriv receptnavn/-kode",
        colorNameCodeStartPlaceholder: "Starte med at skrive et receptnavn/-kode",
        colorNamePlaceholder: "eller indtast et receptnavn",
        colorNameStartPlaceholder: "Indtast et receptnavn",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "eller indtast et farvekort",
        fandeckStartPlaceholder: "Start med at indtaste et farvekort",
        formulaByColor: "Recept efter farve",
        noResultsFound: "Ingen resultater fundet",
        packagePlaceholder: "eller indtast varenummer eller -navn",
        packageStartPlaceholder: "Indtast varenummer eller -navn",
        productPlaceholder: "eller indtast et produktnavn",
        productStartPlaceholder: "Start med at indtaste et produktnavn",
        standard: "Standard",
        typeFandeckToFilter: "SÃ¸g efter farvekort",
        typeProductToFilter: "SÃ¸g efter produktnavn"
    },
    sendOrderModal: {
        customNote: "Note om specialfremstillingen",
        noCompatibleServers: "Ingen kompatible servere er tilgÃ¦ngelige i dit netvÃ¦rk",
        orderOverview: "Ordreoversigt",
        selectTargetMachine: "VÃ¦lg den tilsigtede maskine",
        sendOrder: "Send ordre",
        sendOrderTo: "Dine ordre vil blive sent til %{serverName}",
        targetMachine: "Tilsigtede maskine"
    },
    server: {
        computerId: "Computer ID",
        ip: "IP",
        selectServer: "Veligst vÃ¦lg en af de tilgÃ¦ngelige servere",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Aktive server plug-in",
        currentlyActive: "De aktuelt aktive plug-in",
        plugin: "Plug-in",
        pluginName: "Plug-in navn",
        statusActive: "Aktiver",
        statusInactive: "Deaktiver"
    },
    serviceActionsSettings: {
        canisterLevel: "Kanister niveau",
        capClose: "Luk",
        capMiddle: "Midterste",
        capOpen: "Ãben",
        cleanAllChannels: "RengÃ¸r alle",
        cleanChannels: "RengÃ¸r kanaler",
        computer: "Computer",
        computerReboot: "Computergenstart",
        computerShutdown: "Computernedlukning",
        connectMachine: "Forbind maskine",
        general: "Generel",
        initialize: "Initialisere",
        noMachineIsConnected: "Ingen maskine er forbundet",
        plug: "Slut til",
        plugger: "Tilslutningsknap",
        punch: "Stanser",
        puncher: "Stansningsknap",
        purgeChannels: "Udrens kanaler",
        recirculate: "Recirkuler",
        recirculateAllChannels: "Recirkuler alle",
        recirculateChannels: "Recirkuler kanaler",
        serviceActions: "Service handlinger",
        setCanisterLevel: "Indstil kanister niveauer",
        shelfDown: "Hylde ned",
        shelfUp: "Hylde op",
        showServiceWindow: "Vis servicevindue",
        smartPurgeAllChannels: "Smart udrensning af alle kanaler",
        smartPurgeChannels: "Smarte udrensning af kanaler",
        startErrorReset: "Nulstil startfejl",
        startHardReset: "Start hÃ¥rd nulstilling",
        startReset: "Start nulstilling",
        stirAllCanisters: "OmrÃ¸r alle",
        stirCanisters: "OmrÃ¸r",
        stirCanistersMore: "OmrÃ¸r kanister"
    },
    spectroMode: {
        eggshell: "Ãggeskal",
        flat: "Flad",
        gloss: "Glans",
        matt: "Mat",
        matte: "Mat",
        pearl: "Perle",
        satin: "Satin",
        selectGlossLevel: "Sammenlign farveprÃ¸ven med glansskalaen, og vÃ¦lg glansniveau",
        semiGloss: "Mellemglans"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibrer",
        calibrateInstrument: "Kalibrer instrument",
        connectDevice: "Tilslut enhed",
        connectedTo: "Forbundet til",
        connectingDevice: "Tilslutter din enhed",
        deselectAll: "FravÃ¦lg alle",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Din enhed er ikke kalibreret",
        eraseResult: "Slet resultat",
        filter: "Filter",
        foundInFormulas: "Fundet i recepter",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Dit instrument skal kalibreres.",
        manualInput: "Manuel indtastning",
        measure: "MÃ¥le",
        measurementResult: "MÃ¥leresultat",
        noFilters: "Ingen filtre til rÃ¥dighed",
        noFormulas: "Der blev ikke fundet nogen recepter",
        noSelectedSpectro: "Intet spektrometer er valgt",
        notSelected: "Ikke valgt",
        pressConnectButton: "Kontroller, at din enhed er tilsluttet, og tryk pÃ¥ forbindelsesknappen",
        searchFormulas: "SÃ¸g efter recept",
        selectSpectro: "VÃ¦lg spektrometer",
        showDetails: "Vis detaljer",
        skipCalibration: "Spring kalibrering over",
        spectroIsConnected: "Spektrometeret er forbundet",
        spectroIsReady: "Spektrometeret er klart",
        spectroReady: "Enheden er klar til yderligere opgaver",
        startCalibrateNow: "PÃ¥begynd kalibrering",
        startMeasureText: "Din enhed er kalibreret, og du kan begynde at mÃ¥le",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Tolerance for Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Specialfremstillet %{1} %{2}",
        deleteSelectedRecords: "Slet valgte poster",
        exportHistory: "Eksport historik",
        finishFormula: "FÃ¦rdiggÃ¸r recept",
        foundInFormulas: "Fundet i recepter",
        hideHiddenRecords: "Vis ikke skjulte poster",
        hideSelectedRecord: "Skjul den valgte post",
        historicalFormula: "Historisk formel",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Gendan valgt post",
        showAllRecords: "Vis alle poster",
        standardFormula: "Standard formula",
        unknownFormula: "Ukendt formel"
    },
    stirCanisters: {
        selectCanisters: "VÃ¦lg kanister",
        startStirring: "Start omrÃ¸ring",
        stirAllCanisters: "OmrÃ¸r alle kanistre",
        stirCanisters: "OmrÃ¸r kanistre",
        stirringSpeed: "OmrÃ¸ringshastighed",
        stirringTime: "OmrÃ¸ringstid "
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Intet element er tildelt stregkode %{code}",
        pleaseScanBarcode: "Scan stregkoden for base, produkt, pakke eller andre genstande",
        testBarcodes: "Test stregkode"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Sidste",
        next: "NÃ¦ste"
    },
    ufiCodeModal: {
        currentStatus: "NuvÃ¦rende status",
        detailedInfoForColorant: "Detaljeret information for pasta %{colorantName}",
        userSetUfiCode: "Brugersat UFI kode, aktuel vÃ¦rdi"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI kode validering",
        confirmColorantRefilling: "BekrÃ¦ft genopfyldning pasta",
        enableUfiCodes: "Aktiver UFI koder",
        printUfiCode: "Udskriv, hvis pastamÃ¦ngden er over",
        printUfiCodePercentage: "Udskriv procent, hvis pastamÃ¦ngden er over",
        scanOrTypeUfiCode: "Scan eller indtast UFI kode",
        scanOrTypeUfiCodeOfBase: "Scan eller indtast UFI kode for base spand",
        ufiCodesByPercentage: "Brug UFI koder givet i procent",
        ufiCodesFromDatabase: "Brug UFI koder fra databasen",
        ufiCodesFromLastFilling: "Brug UFI koder fra den sidste pÃ¥fyldning"
    },
    userSettings: {
        addUser: "TilfÃ¸j bruger",
        assignedUserGroups: "Tildelte brugergrupper",
        availableUserGroups: "TilgÃ¦ngelige brugergrupper",
        barcode: "Stregkode",
        confirmNewPassword: "BekrÃ¦ft stregkode",
        editPassword: "Rediger kodeord",
        editUser: "Rediger bruger",
        enableAutoLogin: "AktivÃ©r automatisk login",
        newPassword: "Ny adgangskode",
        noChange: "Der er ingen Ã¦ndringer, der skal gemmes",
        oldPassword: "Gamle adgangskode",
        password: "Adgangskode",
        passwordsDoNotMatch: "Adgangskoderne stemmer ikke overens",
        restoreUser: "Denne bruger er blevet slettet. Vil du gendanne ham?",
        userGroup: "User Group",
        userGroups: "Brugergrupper",
        userManagement: "Brugeradministration",
        userSettings: "Brugerindstillinger",
        username: "Brugernavn",
        usernameIsMissing: "Brugernavn mangler"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Fredag",
        monday: "Mandag",
        saturday: "LÃ¸rdag",
        sunday: "SÃ¸ndag",
        thursday: "Torsdag",
        tuesday: "Tirsdag",
        wednesday: "Onsdag"
    },
    welcome: {
        availableDatabase: "Server kan ikke oprette forbindelse til databasen. Kontroller din databasekonfiguration.",
        availableDatabaseLocalError:
            "Fejl under forbindelse til den lokale database (forkert fil, ugyldig adgangskode)",
        availableDatabaseLocalMissing: "Den lokale dabase-fil mangler",
        availableDatabaseLocalUpdate: "Lokal database skal opdateres til den nyere version",
        availableDatabaseMainAndLocalError:
            "Fejl under forbindelse til bÃ¥de hoved- og lokale databaser (forkert fil, ugyldig adgangskode)",
        availableDatabaseMainAndLocalMissing: "Hoved- og lokale databasefiler mangler",
        availableDatabaseMainAndLocalUpdate: "BÃ¥de hoved- og lokale databaser skal opdateres til den nyere version",
        availableDatabaseMainError: "Fejl under forbindelse til hoveddatabasen (forkert fil, ugyldig adgangskode)",
        availableDatabaseMainMissing: "Hoveddatabasefilen mangler",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Hoveddatabasen skal opdateres til den nyere version",
        closing: "Software lukker",
        compatibility: "Kontroller versionen af din server. Din klient er kun kompatibel med server %{0} eller hÃ¸jere.",
        compatibilityCheck: "Kompatibilitetskontrol er i gang",
        compatibilityDatabase: "Din database er ikke kompatibel med serveren. Kontroller din databasekonfiguration.",
        connectingServer: "Opretter forbindelse til serveren pÃ¥ %{ip}",
        databaseCompatibility: "Din database er ikke kompatibel med den aktuelle software",
        databasesCompatibility: "Dine databaser er ikke kompatible med den aktuelle software",
        licenseVerification: "Licensverifikation er i gang",
        loading: "IndlÃ¦ser",
        lostConnection: "Forbindelsen til serveren er mistet",
        moduleMessage:
            "VÃ¦r opmÃ¦rksom pÃ¥ modulvalget, fordi fremtidig Ã¦ndring af modulet kun vil vÃ¦re tilgÃ¦ngeligt for privilegerede brugere.",
        refresh: "Opdater",
        restoring: "Gendanner forbindelsen",
        selectModule: "VÃ¦lg et af de tilgÃ¦ngelige moduler.",
        stopUpdate: "Stop opdatering",
        updateDatabase: "Opdater database",
        updatingDatabase: "Databasen opdateres",
        updatingDatabases: "Databaser opdateres",
        updatingWarning: "Luk ikke dette vindue. En uoprettelig proces er i gang.",
        updatingWarningInfo: "Lukning vil medfÃ¸re dataskader, der ikke kan repareres."
    }
};
